const MYEPSILON = 0.0001;

import AsyncStorage from '@react-native-async-storage/async-storage';
import base64 from 'react-native-base64'

class GameData {
    idCount = 0;

    getId() {
      this.idCount += 1;
	  for (let i = 0; i < this.code.length; i++) {
		  if (this.code[i].id == this.idCount) {
			  return(this.getId());
		  }
	  }
      return (this.idCount);
    }
		
	version = "0.1.0";

    code = [
    ];

	//RegExp
	//(.*?)disable:(.*?)\R(.*?)\R(.*?)

    actions = [
      {
        name: "Crawl Around",
		//animation: "lichbabybw",
		image: "crawling",
        description: "Take a look around and see what's there with your own eyes. Wait, do I even have eyes?",
        time: 5, // time = basetime * 1/(1+speed) * 1/(1+timescompletedthisrun(momentum))
		exp: 5,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20, // threat = basethreat * 1/(1*stealth)
        //completion: // % graveyard, exp -> speed/perception
        completion: {
          //map: "crawl",
          //location: "foo",
		  //milestone: 'crawl',
		  skill: {
			  swiftness: 1,
			  necropolis: 1,
			  },
		},
        requirements: {
			form: 'baby'
        },
        disable: {
          //map: {
            //crawl: 1,
          //},
        },
      },
	  /*
      {
        name: "Navigate Necropolis",
        image: "exploregrave",
        description: "A necropolis or graveyard. How convenient. If this is where my life is to start, it is best I get to know the place.",
        time: 5, // time = basetime * 1/(1+speed) * 1/(1+timescompletedthisrun(momentum))
		exp: 5,
        timeModifiers: {
          skill: {
            swiftness: 0.2,
            observation: 0.4,
			necropolis: 0.4,
          },
        },
        threat: 20, // threat = basethreat * 1/(1*stealth)
        //completion: // % graveyard, exp -> speed/perception
        completion: {
          milestone: "graveyard",
		  skill: {observation: 2, necropolis: 5},
        },
        requirements: {
           skill: {
            swiftness: 1,
          },
          location: ['graveyard'],
        },
        disable: {
        },
      },
	  */
      {
        name: "Read Tombs",
        image: "exploregrave",
        description: "Read the nearby tombs for any hints about the world or yourself.",
        time: 5,
		exp: 5,
        timeModifiers: {
          //map: {
            //graveyard: 1.1,
          //},
          skill: {
            brains: 1,
          },
        },
        threat: 20,
        completion: {
			skill: {brains: 1, lichdom: 1},
        },
        requirements: {
          //map: {
            //graveyard: 20,
          //},
		  skill: {
            necropolis: 5,
          },
          location: 'graveyard',
        },
        disable: {
        },
      },
      {
        name: "Dig Grave",
        image: "bones",
        description: "Excavating graves to gather those precious bones.",
        time: 1,
		exp: 1,
        timeModifiers: {
          skill: {
            might: 1,
			//necropolis: 0.5,
          },
        },
        outputModifiers: {
          //map: {
            //bones: 1,
          //}
		  skill: {
			  might: 1,
			  necropolis: 0.25, // or 0.5 / 0.25
		  }
        },
        threat: 20,
        completion: {
          inventory: {
            Bones: [0, 1, 0.5], // [base, scaling]
          },
		  skill: {
			  might: 0.2,
		  },
		  milestone: "bones"
          //map: "bones",
        },
        requirements: {
          //map: {
            //graveyard: 10,
          //},
		  skill: {
			  //necropolis: 3,
			  lichdom: 3,
		  },
          location: ['graveyard'],
        },
        disable: {
        },
      },
      {
        name: "Observe Crows",
        image: "observecrows",
        description: "Those crows seem to be up to something suspicious.",
        time: 5,
		exp: 5,
        timeModifiers: {
          skill: {
            observation: 1,
          },
        },
        threat: 20,
        completion: {
			skill: {observation: 1, crows: 1},
        },
        requirements: {
		  skill: {
            necropolis: 6,
          },
          location: 'graveyard',
        },
        disable: {
        },
      },	
      {
        name: "Play in Mud",
        image: "lowerthreat",
        description: "I don't know why it's so fun, but it definitely is.",
        time: 1,
		exp: 1,
        timeModifiers: {
          skill: {
            lurking: 0.5,
			necropolis: 0.5,
          },
        },
        threat: 20, // threat = basethreat * 1/(1*stealth)
        //completion: // % graveyard, exp -> speed/perception
        completion: {
          threat: -40,
		  skill: {
			  lurking: 0.1,
		  },
        },
        requirements: {
		  skill: {
            crows: 2,
          },
		  location: ['graveyard'],
          //form: 'baby',
        },
        disable: {
        },
      },	  
      {
        name: "Catch Crow",
        image: "blood",
        description: "Perhaps not the most productive use of time, but it's a great stress reliever.",
        time: 4,
		exp: 1,
        timeModifiers: {
          skill: {
            swiftness: 0.2,
			observation: 0.2,
            brains: 0.2,
			might: 0.2,
			lurking: 0.2, 
			crows: 4,
          },
        },
        threat: 20,
        //completion: // get bones, ethier bones add power, or enough bones allow for lvl up/grow up
        completion: {
          inventory: {
            Blood: [1, 0, 1],
          },
          //skill: {
            //crows: 1, 
          //},
		  threat: 20,
		  milestone: 'crows',
        },
        requirements: {
		  skill: {
            crows: 4,
          },
          location: ['graveyard'],
        },
        disable: {
        },
      },
      {
        name: "Raise Army",
        image: "corpses",
        description: "Bodies strewn all around.",
        time: 10,
		exp: 0,
        timeModifiers: {
          skill: {
			magic: 1,
          },
        },
		outputModifiers: {
			skill: {
				necromancy: 0.1,
			}
		},
        threat: 20,
        completion: {
			skill: {
				magic: 5,
				necromancy: 5,
			  },
			inventory: {
				Minions: [0, 5, 0.5],
				Corpses: [0, 1, 0.5],
			}
        },
        requirements: {
			location: ['graveyard'],
			skill: {
				necropolis: 10,
				magic: 30,
			},
			flag: "army",
        },
        disable: {
        },
      },
      {
        name: "Craft Bone Staff",
        image: "bones",
        description: "No true wielder of magic is complete without their staff.",
        time: 10,
		exp: 0,
        timeModifiers: {
          skill: {
			thaumaturgy: 1,
          },
        },
		outputModifiers: {
			skill: {
				destruction: 0.1,
			}
		},
        threat: 20,
        completion: {
			skill: {
				thaumaturgy: 5,
				destruction: 5,
			  },
			inventory: {
				Minions: [0, 5, 0.5],
				Bones: [0, 10, 0.5],
			}
        },
        requirements: {
			location: ['graveyard'],
			skill: {
				lichdom: 10,
				thaumaturgy: 30,
			},
			flag: "staff",
        },
        disable: {
        },
      },	  
      {
        name: "Evolve - Kid",
        image: "evolvekid",
        description: "Time to evolve my form into that of a kid.",
        time: 2,
		exp: 5,
        timeModifiers: {
          skill: {
            lichdom: 1,
          },
          inventory: {
            Bones: [5, 5],
            Blood: [1, 5],
          },
        },
        threat: 20,
        completion: {
          milestone: 'Evolve - Kid',
          //location: 'forest',
		  form: 'kid',
        },
        requirements: {
          //milestone: 'crows',
		  skill: {
			  lichdom: 5,
		  },
          //location: ['graveyard'],
		   form: 'baby',
        },
        disable: {
        },
      },
      {
        name: "Go To Graveyard",
        image: "arrow",
        description: "Move to the Graveyard",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'graveyard',
        },
        requirements: {
		  milestone: 'Evolve - Kid',
          location: ['forest',],
        },
        disable: {
        },
      },
      {
        name: "Go To Forest - Mage Hand",
        image: "arrow",
        description: "Move to the Forest",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'forest',
        },
        requirements: {
		  skill : {
			 'class': 3,  
		  },
          location: ['graveyard'],
		  form: 'baby',
        },
        disable: {
        },
      },	  
      {
        name: "Go To Forest",
        image: "arrow",
        description: "Move to the Forest",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'forest',
        },
        requirements: {
		  milestone: 'Evolve - Kid',
          location: ['graveyard', 'swamp', 'school', 'town'],
		  notform: 'baby',
        },
        disable: {
        },
      },
      {
        name: "Bushwhack",
        image: "forestsearch",
        description: "To walk in nature is to... Ah! What was that!",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
            observation: 0.5,
            //lurking: 0.2,
			might: 0.5,
			//forest: 0.2,
          },
        },
        threat: 20,
        completion: {
          skill: {
			  might: 2,
            forest: 1,
          },
        },
        requirements: {
          milestone: "Evolve - Kid",
          location: ['forest'],
        },
        disable: {
        },
      },
      {
        name: "Feign Death",
        image: "lowerthreat",
        description: "Zzz...",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
            lurking: 0.2,
			brains: 0.8,
          },
        },
        threat: 20,
        completion: {
          threat: -40,
		  skill: {
            brains: 0.2,
          },
        },
        requirements: {
          location: ['forest'],
		  skill: {
            forest: 1,
          },
        },
        disable: {
        },
      },
      {
        name: "Collect Wood",
        image: "supplies",
        description: "What adventure doesn't begin with collecting wood?",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
			  observation: 0.8,
              might: 0.2,
          },
        },
		outputModifiers: {
		  skill: {
			  observation: 0.5,
			  forest: 0.5,
		  }
        },
        threat: 20,
        completion: {
          inventory: {
            //Wood: [0, 1, 0.5],
			Supplies: [0, 1, 0.5],
          },
		  skill: {
			  observation: 0.4,
		  }
        },
        requirements: {
          skill: {
            forest: 2,
          },
          location: ['forest'],
        },
        disable: {
        },
      },
      {
        name: "Hunt Critters",
		image: "blood",
        description: "If it bleeds, it can be utilized.",
        time: 3,
		exp: 2,
        timeModifiers: {
          skill: {
            swiftness: 0.4,
			might: 0.2,
            lurking: 0.4,
            //observation: 0.2,
			//brains: 0.2,
			//critters: 5,
			forest: 3,
          },
        },
		outputModifiers: {
		  skill: {
			  critters: 1,
		  }
        },
        threat: 20,
        completion: {
          inventory: {
            Blood: [0, 1, 0.5],
          },
		  skill: {
            swiftness: 2,
			critters: 1,
          },
		  threat: 40,
        },
        requirements: {
          location: ['forest'],
		  skill: {
            forest: 4,
          },
        },
        disable: {
        },
      },
      {
        name: "Siphon Mana",
		image: "magic",
        description: "Small fragments of mana, remnants of a distant past.",
        time: 1,
		exp: 1,
        timeModifiers: {
          skill: {
			magic: 0.5,
			forest: 0.5,
          },
        },
        threat: 20,
        completion: {
          inventory: {
            //Mana: [0, 1, 0.5]
			Mana: [5, 0, 1]
          },
		  skill: {
			magic: 0.4,
          },
        },
		/*
		outputModifiers: {
          skill: {
            magic: 1,
          }
        },
		*/
        requirements: {
          location: ['forest'],
		  skill: {
            forest: 7,
          },
        },
        disable: {
        },
      },
      {
        name: "Release Mana Spring",
        image: "magic",
        description: "Demolition in 3, 2, 1...",
        time: 10,
		exp: 0,
        timeModifiers: {
          skill: {
			destruction: 1,
          },
		  inventory: {
			Mana: [500, 10],
		  },
        },
		outputModifiers: {
			skill: {
				magic: 0.1,
			}
		},
        threat: 20,
        completion: {
			skill: {
				destruction: 5,
				magic: 5,
			  },
			inventory: {
				Minions: [0, 5, 0.5],
				Mana: [0, 1000, 0.5],
			}
        },
        requirements: {
			location: ['forest'],
			skill: {
				forest: 10,
				destruction: 30,
			},
			flag: "spring",
        },
        disable: {
        },
      },	
      {
        name: "Bind Planar Beings",
        image: "supplies",
        description: "One Lich to bind them all together.",
        time: 10,
		exp: 0,
        timeModifiers: {
          skill: {
			domination: 1,
          },
        },
		outputModifiers: {
			skill: {
				mysticism: 0.1,
			}
		},
        threat: 20,
        completion: {
			skill: {
				domination: 5,
				mysticism: 5,
			  },
			inventory: {
				Minions: [0, 5, 0.5],
				Supplies: [0, 10, 0.5],
			}
        },
        requirements: {
			location: ['forest'],
			skill: {
				forest: 20,
				domination: 30,
			},
			flag: "planar",
        },
        disable: {
        },
      },	  
      {
        name: "Go To Swamp",
        image: "arrow",
        description: "Move to the Swamp",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'swamp',
        },
        requirements: {
          skill: {
            forest: 3,
          },
          location: ['forest'],
        },
        disable: {
        },
      },
      {
        name: "Swamp Sifting",
        image: "swampglass",
        description: "Good thing my robe gets refreshed with each life.",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
			might: 0.4,
            swiftness: 0.4,
            observation: 0.2,
            //lurking: 0.2,
          },
        },
        threat: 20,
        completion: {
          skill: {
            swiftness: 1,
			observation: 1,
            swamp: 1,
          },
        },
        requirements: {
          location: ['swamp'],
        },
        disable: {
        },
      },
      {
        name: "Blend In",
        image: "lowerthreat",
        description: "I've found a good use for blowing bubbles.",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
            lurking: 0.5,
			swamp: 0.5,
          },
        },
        threat: 20,
        completion: {
          threat: -40,
		  skill: {
            lurking: 0.2,
          },
        },
        requirements: {
          location: ['swamp'],
		  skill: {
            swamp: 1,
          },
        },
        disable: {
        },
      },
      {
        name: "Dredge Swamp",
        image: "bones",
        description: "Utilize supplies to dredge up bones from the swamp floor.",
        time: 2,
		exp: 4,
        timeModifiers: {
          skill: {
			observation: 0.2,
            might: 0.2,
			swamp: 0.6,
          },
		  inventory: {
			  //Wood: [1,2]
			  Supplies: [1,2]
		  }
        },
        outputModifiers: {
          skill: {
			might: 0.5,
            swamp: 0.5,
          }
        },
        threat: 20,
        completion: {
          inventory: {
            Bones: [0, 2, 0.5],
          },
          skill: {
            might: 0.8,
          },
        },
        requirements: {
          location: ['swamp'],
		  skill: {
            swamp: 2,
          },
        },
        disable: {
        },
      },
      {
        name: "Collect Shrooms",
        image: "shrooms",
        description: "They don't look edible, but perhaps they have other uses.",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
			  observation: 0.75,
            swamp: 0.25,
          },
        },
        outputModifiers: {
          skill: {
			  observation: 0.5,
            swamp: 0.5,
          },
        },
        threat: 20,
        completion: {
          inventory: {
            Shrooms: [0, 2, 0.5],
          },
		  skill: {
			  observation: 0.4,
          },
          //map: "shrooms",
        },
        requirements: {
          location: ['swamp'],
		  skill: {
            swamp: 3,
          },
        },
        disable: {
        },
      },
      {
        name: "Steal Orb",
        image: "potions",
        description: "Naturally, it belongs to me.",
        time: 10,
		exp: 0,
        timeModifiers: {
          skill: {
			mysticism: 1,
          },
        },
		outputModifiers: {
			skill: {
				thaumaturgy: 0.1,
			}
		},
        threat: 20,
        completion: {
			skill: {
				mysticism: 5,
				thaumaturgy: 5,
			  },
			inventory: {
				Minions: [0, 5, 0.5],
				Potions: [0, 5, 0.5],
			}
        },
        requirements: {
			location: ['swamp'],
			skill: {
				swamp: 10,
				mysticism: 30,
			},
			flag: "orb",
        },
        disable: {
        },
      },
      {
        name: "Zombie Dragon",
        image: "mount",
        description: "Now, what should I name you?",
        time: 10,
		exp: 0,
        timeModifiers: {
          skill: {
			necromancy: 1,
          },
        },
		outputModifiers: {
			skill: {
				domination: 0.1,
			}
		},
        threat: 20,
        completion: {
			skill: {
				necromancy: 5,
				domination: 5,
			  },
			inventory: {
				Minions: [0, 5, 0.5],
				Mount: [0, 5, 0.5],
			}
        },
        requirements: {
			location: ['swamp'],
			skill: {
				swamp: 20,
				necromancy: 30,
			},
			flag: "dragon",
        },
        disable: {
        },
      },	  
      {
        name: "Evolve - Teenager",
        image: "evolveteen",
        description: "Time to evolve my form into that of a teenager.",
        time: 4,
		exp: 8,
        timeModifiers: {
          skill: {
            brains: 1,
          },
          inventory: {
            Bones: [50, 5],
            Blood: [5, 5],
          },
        },
        threat: 20,
        completion: {
          milestone: 'Evolve - Teenager',
		  form: 'teen',
        },
        requirements: {
			milestone: 'Evolve - Kid',
          skill: {
            forest: 6,
          },
		  form: 'kid'
        },
        disable: {
        },
      },
	  /*
      {
        name: "Go To School",
        image: "arrow",
        description: "Move to the school",
        time: 1,
		exp: 2,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'school',
        },
        requirements: {
		  milestone: 'Evolve - Teenager',
		  form: 'teen',
		  location: ['forest'],
        },
        disable: {
        },
      },
	  */
      {
        name: "Tour Campus",
        image: "tourschool",
        description: "Walking backwards doesn't really help, but it somehow feels appropriate.",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
            swiftness: 0.4,
            observation: 0.2,
            brains: 0.4,
			//school: 0.2,
          },
        },
        threat: 20,
        completion: {
			milestone: "school",
          skill: {
			school: 1,
			swiftness: 0.5,
			brains: 0.5,
			observation: 0.5,
          },
        },
        requirements: {
			form: 'teen',
          location: ['school'],
        },
        disable: {
        },
      },
	  {
        name: "Attend Class",
        image: "class",
        description: "What does 'M' stand for?",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
            brains: 0.5,
            magic: 0.5,
          },
          inventory: {
            Mana: [5, 2],
          },
        },
        threat: 20,
        completion: {
          skill: {
            brains: 0.75,
            magic: 0.75,
			'class': 1,
          },
        },
        requirements: {
			form: 'teen',
          location: ['school'],
		  skill: {
            school: 2,
          },
        },
        disable: {
        },
      },
	  {
        name: "Give Answers",
        image: "spoils",
        description: "There's an entire section dedicated to cantrips.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
			  lurking: 0.2,
            brains: 0.2,
            'class': 0.6,
          },
        },
        threat: 20,
		completion: {
			skill: {
			  manipulation: 0.6,
          },
			inventory: {
			  Spoils: [0, 1, 0.5],
			  //Debts: [1,0,1],
			},
		},
		outputModifiers: {
			skill: {
			  //brains: 0.5,
			  'class': 1,
			},
		},
        requirements: {
			form: 'teen',
          location: ['school'],
		  skill: {
            'class': 2,
          },
        },
        disable: {
        },
      },
	  {
        name: "Pull Prank",
        image: "lowerthreat",
        description: "Now, if we could only get our hands on a dragon, the sparks would really fly.",
        time: 2,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.2,
			manipulation: 0.4,
			magic: 0.4,
          },
		  inventory: {
			  Spoils: [1, 2]
		  }
        },
        threat: 20,
        completion: {
          threat: -80,
		  skill: {
			manipulation: 0.2,
			magic: 0.2,
			swiftness: 0.2,
          },
        },
        requirements: {
			form: 'teen',
          location: ['school'],
		  skill: {
            school: 3,
          },
        },
        disable: {
        },
      },
	  {
        name: "Mana Font",
        image: "magic",
        description: "There's often a long line between classes.",
        time: 2,
		exp: 4,
        timeModifiers: {
          skill: {
			manipulation: 0.5,
			magic: 0.5,
          },
		  inventory: {
			  Spoils: [1, 2]
		  }
        },
        threat: 20,
        completion: {
		  skill: {
			manipulation: 0.3,
			magic: 0.3,
          },
		  inventory: {
			  Mana: [0, 10, 0.5] // math says 13.33
		  }
        },
		outputModifiers: {
          skill: {
            magic: 0.5,
			school: 0.5,
          }
        },	
        requirements: {
			form: 'teen',
          location: ['school'],
		  skill: {
            school: 4,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To A Club",
        image: "arrow",
        description: "Make your way towards one of the school clubs.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			school: 0.5,
          },
        },
        threat: 20,
        completion: {
          location: 'club',
        },
        requirements: {
			form: 'teen',
          location: ['school', 'ww', 'ee', 'pp', 'aa', 'lan'],
		  skill: {
            school: 5,
          },
        },
        disable: {
        },
      },
      {
        name: "Back To School",
        image: "backarrow",
        description: "Move back to the school.",
        time: 2,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			school: 0.5,
          },
        },
        threat: 20,
        completion: {
          location: 'school',
        },
        requirements: {
			form: 'teen',
          location: ['ww', 'ee', 'pp', 'aa', 'lan', 'crypts'],
		  skill: {
            school: 5,
          },
        },
        disable: {
        },
      },
	  {
        name: "Go To Wierd Weeds",
        image: "arrow",
        description: "Move to the Wierd Weeds club.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			school: 0.5,
          },
        },
        threat: 20,
        completion: {
          location: 'ww',
        },
        requirements: {
			form: 'teen',
          location: ['club'],
		  skill: {
            school: 5,
          },
        },
        disable: {
        },
      },
	  {
        name: "Get Weeding",
        image: "ww",
        description: "It's mundane work, but afterwards, they share some of the concoctions they've made.",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
			  might: 0.5,
            thaumaturgy: 0.5,
          },
          //inventory: {
            //Shrooms: [5, 2],
          //},
        },
        threat: 20,
        completion: {
			skill: {
			  might: 1,
            thaumaturgy: 2,
			ww: 1,
          },
        },
        requirements: {
			form: 'teen',
          location: ['ww'],
        },
        disable: {
        },
      },
	  {
        name: "Donate Ingredients",
        image: "spoils",
        description: "They're really appreciative of getting their hands on the good stuff.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
          inventory: {
            Shrooms: [5, 5],
          },
        },
        threat: 20,
        completion: {
			skill: {
            manipulation: 0.6,
          },
          inventory: {
			  Spoils: [0, 2, 0.5],
		  }
        },
		outputModifiers: {
          skill: {
			  manipulation: 0.5,
            ww: 0.5,
          }
        },	
        requirements: {
			form: 'teen',
			location: ['ww'],
		  skill: {
            ww: 4,
          },
        },
        disable: {
        },
      },
	  /*
	  {
        name: "Mana Potion",
        image: "exploregrave",
        description: "",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            thaumaturgy: 1,
          },
          inventory: {
            Shrooms: [5, 5],
          },
        },
        threat: 20,
        completion: {
          inventory: {
			  Mana: [0, 25, 0.5],
		  },
		  skill: {
            thaumaturgy: 0.2,
          },
        },
		outputModifiers: {
          skill: {
            thaumaturgy: 1,
          }
        },
        requirements: {
			form: 'teen',
			location: ['ww'],
		  skill: {
            ww: 2,
          },
        },
        disable: {
        },
      },
	  */
	  {
        name: "Brew Potion",
        image: "potions",
        description: "Remember, don't drink after midnight.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            thaumaturgy: 1,
          },
          inventory: {
            Shrooms: [25, 5],
          },
        },
        threat: 20,
        completion: {
          inventory: {
			  Potions: [0, 1, 0.5],
		  },
		  skill: {
            thaumaturgy: 0.6,
          },
        },
		outputModifiers: {
          skill: {
            thaumaturgy: 0.5,
			ww: 0.5,
          }
        },	
        requirements: {
			form: 'teen',
			location: ['ww'],
		  skill: {
            ww: 6,
          },
        },
        disable: {
        },
      },
	  {
        name: "Go To Equestrians for Equality",
        image: "arrow",
        description: "Move to the Equestrians for Equality club.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			school: 0.5,
          },
        },
        threat: 20,
        completion: {
          location: 'ee',
        },
        requirements: {
			form: 'teen',
          location: ['club'],
		  skill: {
            school: 6,
          },
        },
        disable: {
        },
      },
	  {
        name: "Debate",
        image: "ee",
        description: "Time to get off your high horse!",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
			manipulation: 0.5,
            domination: 0.5,
          },
        },
        threat: 20,
        completion: {
		  skill: {
			manipulation: 1,
            domination: 2,
			ee: 1,
          },
        },
        requirements: {
			form: 'teen',
          location: ['ee'],
        },
        disable: {
        },
      },
	  {
        name: "Tend To Creatures",
        image: "spoils",
        description: "Who's a good basilisk?",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
            domination: 1,
          },
        },
        threat: 20,
        completion: {
          inventory: {
			  Spoils: [0, 3, 0.5],
		  },
		  skill: {
            domination: 3,
          }
        },
		outputModifiers: {
          skill: {
            domination: 0.5,
			ee: 0.5,
          }
        },	
        requirements: {
			form: 'teen',
          location: ['ee'],
		  skill: {
            ee: 4,
          },
        },
        disable: {
        },
      },
	  {
        name: "Borrow Mount",
        image: "mount",
        description: "Of course, I'll return it.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
			  manipulation: 0.5,
            domination: 0.5,
          },
          inventory: {
            Spoils: [5, 5],
          },
        },
        threat: 20,
        completion: {
          inventory: {
			  Mount: [0, 1, 0.5],
		  }
        },
		outputModifiers: {
          skill: {
			  domination: 0.5,
            ee: 0.5,
          }
        },	
        requirements: {
			form: 'teen',
          location: ['ee'],
		  skill: {
            ee: 6,
          },
        },
        disable: {
        },
      },
	  {
        name: "Go To Planar Problems",
        image: "arrow",
        description: "Move to the Planar Problems club",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			school: 0.5,
          },
        },
        threat: 20,
        completion: {
         location: 'pp',
        },
        requirements: {
			form: 'teen',
          location: ['club'],
		  skill: {
            school: 7,
          },
        },
        disable: {
        },
      },
	  {
        name: "Listen to Theories",
        image: "pp",
        description: "I'm fond of the theory that we're all in a simulation.",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
			  observation: 0.5,
            mysticism: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
			observation: 1,
            mysticism: 3,
			pp: 1,
          },
        },
        requirements: {
			form: 'teen',
          location: ['pp'],
        },
        disable: {
        },
      },
	  {
        name: "Scry The Sky",
        image: "spoils",
        description: "I think I just saw a shadow.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
			  //magic: 0.2,
			  observation: 0.5,
            mysticism: 0.5,
          },
          inventory: {
            Mana: [10, 3],
          },
        },
        threat: 20,
        completion: {
			skill: {
				observation: 0.3,
            mysticism: 0.3,
          },
          inventory: {
			  Spoils: [0, 3, 0.5],
		  }
        },
		outputModifiers: {
          skill: {
			  mysticism: 0.5,
            pp: 0.5,
          }
        },	
        requirements: {
			form: 'teen',
			location: ['pp'],
		  skill: {
            pp: 4,
          },
        },
        disable: {
        },
      },
	  {
        name: "Scry Threats",
        image: "lowerthreat",
        description: "How do you focus this thing?",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
			  //magic: 0.2,
			  observation: 0.5,
            mysticism: 0.5,
          },
		  inventory: {
			  Mana: [10, 5],
		  }
        },
        threat: 20,
        completion: {
          threat: -80,
		  skill: {
            //magic: 0.1,
				observation: 0.15,
            mysticism: 0.15,
          },
        },
        requirements: {
			form: 'teen',
			location: ['pp'],
		  skill: {
            pp: 6,
          },
        },
        disable: {
        },
      },
	  {
        name: "Go To Ascendant Adventurers",
        image: "arrow",
        description: "Move to the Ascendant Adventurers club.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			school: 0.5,
          },
        },
        threat: 20,
        completion: {
          location: 'aa',
        },
        requirements: {
			form: 'teen',
          location: ['club'],
		  skill: {
            school: 9,
          },
        },
        disable: {
        },
      },
	  {
        name: "Safety First",
        image: "aa",
        description: "If you can dodge a staff, you can dodge a lightning bolt.",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
			  swiftness: 0.5,
            destruction: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
			  swiftness: 1,
            destruction: 2,
			aa: 1.
          },
        },
        requirements: {
			form: 'teen',
          location: ['aa'],
        },
        disable: {
        },
      },
	  {
        name: "Practice Gear",
        image: "supplies",
        description: "Trade some coins for nifty supplies.",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
			  manipulation: 1,
          },
		  inventory: {
			  Spoils: [1, 5],
		  }
        },
        threat: 20,
        completion: {
			skill: {
			  manipulation: 0.6,
          },
          inventory: {
			  Supplies: [0, 1.5, 0.5],
		  }
        },
		outputModifiers: {
          skill: {
            manipulation: 0.5,
			aa: 0.5,
          }
        },
        requirements: {
			form: 'teen',
			skill: {
				aa: 4,
          },
          location: ['aa'],
        },
        disable: {
        },
      },
	  {
        name: "Sling Spells",
        image: "spoils",
        description: "Are we sure this is safe?",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
			  destruction: 1,
          },
		  inventory: {
			  Mana: [25, 5],
		  }
        },
        threat: 20,
        completion: {
			skill: {
			  destruction: 3,
          },
          inventory: {
			  Spoils: [0, 5, 0.5],
		  }
        },
		outputModifiers: {
          skill: {
            destruction: 0.5,
			aa: 0.5,
          }
        },
        requirements: {
			form: 'teen',
			skill: {
				aa: 6,
          },
          location: ['aa'],
        },
        disable: {
        },
      },
	  {
        name: "Go To Live Action Necromancy",
        image: "arrow",
        description: "Move to the Live Action Necromancy club",
        time: 1,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			school: 0.5,
          },
        },
        threat: 20,
        completion: {
          location: 'lan',
        },
        requirements: {
			form: 'teen',
          location: ['club'],
		  skill: {
            school: 10,
          },
        },
        disable: {
        },
      },
	  {
        name: "Read Rules",
        image: "lan",
        description: "If the two rats are flanking, gain a +1 to scratch.",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
			  brains: 0.5,
            necromancy: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
			  brains: 1,
            necromancy: 2,
			lan: 1,
          },
        },
        requirements: {
			form: 'teen',
          location: ['lan'],
        },
        disable: {
        },
      },
	  {
        name: "Battle",
        image: "spoils",
        description: "Can't we just play for fun?",
        time: 5,
		exp: 4,
        timeModifiers: {
          skill: {
			  brains: 0.5,
            necromancy: 0.5,
          },
		  inventory: {
			  Spoils: [5, 2],
		  }
        },
        threat: 20,
        completion: {
			skill: {
            brains: 2,
			necromancy: 1,
          },
		  inventory: {
			  Spoils: [0, 5, 0.5],
		  },
        },
		outputModifiers: {
			skill: {
				necromancy: 0.5,
				lan: 0.5,
			},
        },
        requirements: {
			form: 'teen',
          location: ['lan'],
		  skill: {
			  lan: 4,
		  }
        },
        disable: {
        },
      },
	  {
        name: "Ritual",
        image: "blood",
        description: "That's an alarming amount of blood.",
        time: 5,
		exp: 4,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Spoils: [5, 5],
		  }
        },
        threat: 20,
        completion: {
			skill: {
				manipulation: 1,
			},
		  inventory: {
			  Blood: [0, 3, 0.5],
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.5,
				lan: 0.5,
			}
        },
        requirements: {
			form: 'teen',
          location: ['lan'],
		  skill: {
			  lan: 6,
		  }
        },
        disable: {
        },
      },
	  {
        name: "Go To Crypts",
        image: "arrow",
        description: "Move to the Crypts",
        time: 2,
		exp: 4,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			school: 0.5,
          },
        },
        threat: 20,
        completion: {
          location: 'crypts',
        },
        requirements: {
			form: 'teen',
          location: ['school'],
		  skill: {
            school: 11,
          },
        },
        disable: {
        },
      },
	  {
        name: "Loot Crypt - Fight",
        image: "minions",
        description: "With the right weapon, I bet I could bash a ton with one quick strike.",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
            might: 1,
          },
		  inventory: {
			  Supplies: [15, 5], // maybe 13
		  }
        },
        threat: 20,
        completion: {
			skill: {
            might: 3,
			crypts: 1,
          },
		  inventory: {
			Bones: [0, 10, 0.5],  
		  },
        },
		outputModifiers: {
			skill: {
				might: 0.25,
				crypts: 0.5,
			}
        },
        requirements: {
			form: 'teen',
          location: ['crypts'],
        },
        disable: {
        },
      },
	  {
        name: "Loot Crypt - Magic Missile",
        image: "magic",
        description: "No escape!",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
			  magic: 1,
            destruction: 2,
          },
		  inventory: {
			  Mana: [75, 5], // maybe 65
		  }
        },
        threat: 20,
        completion: {
			skill: {
            destruction: 3,
			crypts: 1,
          },			
		  inventory: {
			Bones: [0, 10, 0.5],  
		  },
        },
		outputModifiers: {
			skill: {
				destruction: 0.5,
				crypts: 0.5,
			}
        },
        requirements: {
			form: 'teen',
          location: ['crypts'],
		  skill: {
			  'class': 5,
		  }
        },
        disable: {
        },
      },
	  {
        name: "Loot Crypt - Stealth",
        image: "potions",
        description: "Smoke bomb!",
        time: 5,
		exp: 16,
        timeModifiers: {
          skill: {
			  swiftness: 1,
            lurking: 2,
          },
		  inventory: {
			  Potions: [1, 5],
		  }
        },
        threat: 20,
        completion: {
          	skill: {
            lurking: 3,
			crypts: 1,
          },	
		  inventory: {
			Bones: [0, 10, 0.5],  
		  },
        },
		outputModifiers: {
			skill: {
				lurking: 0.25,
				crypts: 0.5,
			}
        },
        requirements: {
			form: 'teen',
          location: ['crypts'],
        },
        disable: {
        },
      },
      {
        name: "Evolve - Adult",
        image: "evolveadult",
        description: "Time to evolve my form into that of an adult.",
        time: 8,
		exp: 64,
        timeModifiers: {
          skill: {
            lichdom: 1,
          },
          inventory: {
            Bones: [200, 5],
            Blood: [20, 5],
          },
        },
        threat: 20,
        completion: {
          milestone: 'evolve3',
		  form: 'youngAdult',
        },
        requirements: {
			milestone: 'Evolve - Teenager',
          skill: {
            school: 12,
          },
		  form: 'teen'
        },
        disable: {
        },
      },
      {
        name: "Go To Town",
        image: "arrow",
        description: "Move to the Town",
        time: 1,
		exp: 80,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
          inventory: {
            Mount: [1, 5],
          },
        },
        threat: 20,
        completion: {
		  location: 'town',
        },
        requirements: {
			milestone: 'evolve3',
			form: 'youngAdult',
			location: ['school', 'ww', 'ee', 'pp', 'aa', 'lan', 'club', 'crypts', 'forest', 'uptown', 'midtown', 'lowtown']
        },
        disable: {
        },
      },
	  /*
	  {
        name: "Takeover Town",
        image: "evolve",
        description: "Temp End Goal. No idea if too easy or too hard.",
        time: 50,
		exp: 256,
        timeModifiers: {
          skill: {
            might: 0.2,
			brains: 0.2,
			magic: 0.2,
			destruction: 0.2,
			necromancy: 0.2,
          },
          inventory: {
            Minions: [5, 5],
            Support: [5, 5],
			Weapons: [25, 5],
			Supplies: [25, 5],
			Mana: [100, 5],
          },
        },
        threat: 20,
        completion: {
          milestone: 'town1',
        },
        requirements: {
			location: ['town'],
		},
        disable: {
        },
      },
	  */
	  {
        name: "Frontal Assault",
        image: "minions",
        description: "Through sheer force and numbers, I can break through.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			brains: 1,
          },
		  inventory: {
            Minions: [50, 10],
          },
        },
        threat: 20,
        completion: {
		  location: 'assault1finish',
        },
        requirements: {
			location: ['assault1'],
		},
        disable: {
        },
      },
	  {
        name: "Earthquake",
        image: "magic",
        description: "A mighty earthquake should bring down the walls.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			destruction: 1,
          },
		  inventory: {
            Mana: [8000, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			destruction: 8,
          },
		  location: 'assault1finish',
        },
        requirements: {
			location: ['assault1'],
		},
        disable: {
        },
      },
	  {
        name: "Siege Weapons",
        image: "supplies",
        description: "A trusty trebuchet, positioned 300 meters away, should do the trick.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			observation: 1,
          },
		  inventory: {
            Supplies: [1500, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			observation: 8,
          },
		  location: 'assault1finish',
        },
        requirements: {
			location: ['assault1'],
		},
        disable: {
        },
      },
	  {
        name: "Bombs",
        image: "potions",
        description: "I bet there's a drain somewhere around here.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			thaumaturgy: 1,
          },
		  inventory: {
            Potions: [125, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			thaumaturgy: 8,
          },
		  location: 'assault1finish',
        },
        requirements: {
			location: ['assault1'],
		},
        disable: {
        },
      },	
	  {
        name: "Ogre Zombie",
        image: "corpses",
        description: "Apart from the smell, it's actually quite fun to be around.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			necromancy: 1,
          },
		  inventory: {
            Corpses: [20, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			necromancy: 8,
          },
		  location: 'assault1finish',
        },
        requirements: {
			location: ['assault1'],
		},
        disable: {
        },
      },
	  {
        name: "Infiltrate",
        image: "spoils",
        description: "Sufficient gold always buys passage.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			lurking: 1,
          },
		  inventory: {
            Spoils: [1500, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			lurking: 8,
          },
		  location: 'assault1finish',
        },
        requirements: {
			location: ['assault1'],
		},
        disable: {
        },
      },
	  {
        name: "Go To Inner Sanctum",
        image: "arrow",
        description: "Move into the castle",
        time: 1,
		exp: 256,
        timeModifiers: {
          skill: {
			swiftness: 1,
          },
        },
        threat: 20,
        completion: {
		  location: 'assault2',
        },
        requirements: {
			location: ['assault1finish'],
		},
        disable: {
        },
      },	  
	  {
        name: "Hall Brawl",
        image: "minions",
        description: "Take the castle inch by inch.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			swiftness: 1,
          },
		  inventory: {
            Minions: [25, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			swiftness: 8,
          },
		  location: 'assault3',
        },
        requirements: {
			location: ['assault2'],
		},
        disable: {
        },
      },	
	  {
        name: "Mass Enchantment",
        image: "magic",
        description: "Convince the last diehard defenders to lay down their arms.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			domination: 1,
          },
		  inventory: {
            Mana: [4000, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			domination: 8,
          },
		  location: 'assault3',
        },
        requirements: {
			location: ['assault2'],
		},
        disable: {
        },
      },
	  {
        name: "Insurrection",
        image: "support",
        description: "Not all our defenders are diehard fanatics. With the right leverage, they'll flip.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			manipulation: 1,
          },
		  inventory: {
            Support: [250, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			manipulation: 8,
          },
		  location: 'assault3',
        },
        requirements: {
			location: ['assault2'],
		},
        disable: {
        },
      },
	  {
        name: "Horrific Visions",
        image: "magic",
        description: "Plague the defenders' minds with visions of their demise.",
        time: 10,
		exp: 256,
        timeModifiers: {
          skill: {
			mysticism: 1,
          },
		  inventory: {
            Mana: [4000, 10],
          },
        },
        threat: 20,
        completion: {
			skill: {
			mysticism: 8,
          },
		  milestone: 'confront',
		  location: 'assault3',
        },
        requirements: {
			location: ['assault2'],
		},
        disable: {
        },
      },	  
	  {
        name: "Battle Gavriel",
        image: "minions",
        description: "This is it.",
        time: 100,
		exp: 256,
        timeModifiers: {
          skill: {
			  swiftness: 0.1,
			might: 0.1,
			brains: 0.1,
			observation: 0.1,
			lurking: 0.1,
			manipulation: 0.1,
			magic: 0.1,
			destruction: 0.1,
			domination: 0.1,
			mysticism: 0.1,
			thaumaturgy: 0.1,
			necromancy: 0.1,
          },
        },
        threat: 20,
        completion: {
			milestone: 'victory',
		  location: 'victory',
        },
        requirements: {
			location: ['assault3'],
		},
        disable: {
        },
      },			  
      {
        name: "Go To Uptown",
        image: "arrow",
        description: "Move to Uptown.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
		  inventory: {
            Mount: [1, 5],
          },
        },
        threat: 20,
        completion: {
          location: 'uptown',
        },
        requirements: {
			location: ['town'],
			skill: {
            triangle: 2,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To Midtown",
        image: "arrow",
        description: "Move to Midtown.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
		  inventory: {
            Mount: [1, 5],
          },
        },
        threat: 20,
        completion: {
          location: 'midtown',
        },
        requirements: {
			location: ['town'],
        },
        disable: {
        },
      },
      {
        name: "Go To Lowtown",
        image: "arrow",
        description: "Move to Lowtown",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
			//lurking: 0.5,
          },
		  inventory: {
            Mount: [1, 5],
          },
        },
        threat: 20,
        completion: {
          location: 'lowtown',
        },
        requirements: {
			location: ['town'],
			skill: {
            triangle: 1,
          },
        },
        disable: {
        },
      },
	  {
        name: "Confront Gavriel",
        image: "minions",
        description: "Ever since Gavriel saw me, he's been holed up in the castle, surrounded by a plethora of soldiers preventing entry.",
        time: 1,
		exp: 256,
        timeModifiers: {
          skill: {
			brains: 1,
          },
        },
        threat: 20,
        completion: {
          //milestone: 'town1',
		  location: 'assault1',
        },
        requirements: {
			location: ['town'],
		},
        disable: {
        },
      },	  
	  /*
      {
        name: "Explore Lowtown",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 0.4,
            observation: 0.2,
			lurking: 0.4,
          },
        },
        threat: 20,
        completion: {
          skill: {
            lowtown: 1,
          },
        },
        requirements: {
			location: ['lowtown'],
        },
        disable: {
        },
      },
      {
        name: "Explore Midtown",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          skill: {
            midtown: 1,
          },
        },
        requirements: {
			location: ['midtown'],
        },
        disable: {
        },
      },
      {
        name: "Explore Uptown",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          skill: {
            uptown: 1,
          },
        },
        requirements: {
			location: ['uptown'],
        },
        disable: {
        },
      },
	  */

	  // Midtown stuff
	  {
        name: "Go To Town Triangle",
        image: "arrow",
        description: "Move to the Town Triangle",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'triangle',
        },
        requirements: {
			location: ['midtown'],
        },
        disable: {
        },
      },
	        {
        name: "Go To Market",
        image: "arrow",
        description: "Move to the Market",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'market',
        },
        requirements: {
			location: ['midtown'],
          skill: {
            triangle: 4,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To Apothecary",
        image: "arrow",
        description: "Move to the Apothecary",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'apothecary',
        },
        requirements: {
			location: ['midtown'],
          skill: {
            market: 4,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To Cartel",
        image: "arrow",
        description: "Move to the Cartel",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'cartel',
        },
        requirements: {
			location: ['midtown'],
          skill: {
            apothecary: 4,
          },
        },
        disable: {
        },
      },	  
      {
        name: "Back to Midtown",
        image: "backarrow",
        description: "Back to midtown",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'midtown',
        },
        requirements: {
			location: ['triangle', 'market', 'apothecary', 'cartel',],
        },
        disable: {
        },
      },	
      {
        name: "Wander",
        image: "wander",
        description: "I wonder what areas and treasures can be found around here.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          skill: {
			  swiftness: 4,
			triangle: 1,
			},
        },
        requirements: {
			location: ['triangle'],
        },
        disable: {
        },
      },
	  {
        name: "Rent Horse",
        image: "mount",
        description: "A few gold coins for a horse to travel around town.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Spoils: [5, 5],
		  }
        },
        threat: 20,
        completion: {
		  inventory: {
			  Mount: [0, 1, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				domination: 0.25,
				triangle: 1,
			}
		},
        requirements: {
			location: ['triangle'],
			skill: {
				triangle: 3,
			}
        },
        disable: {
        },
      },	  
      {
        name: "Pickpocket",
        image: "spoils",
        description: "How does a looping economy even function?",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            lurking: 1,
          },
        },
        threat: 20,
        completion: {
          skill: {
				lurking: 4,
			},
		  inventory: {
			  Spoils: [0, 4, 0.5],
		  }
        },
		outputModifiers: {
			skill: {
				lurking: 0.1,
				triangle: 1,
			},
		},
        requirements: {
			location: ['triangle'],
			skill: {
				triangle: 5,
			}
        },
        disable: {
        },
      },
      {
        name: "Stall Shopping",
        image: "lowerthreat",
        description: "As long as I shell out a gold or two, I should appear innocent enough.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  swiftness: 0.2,
            observation: 0.8,
          },
		  inventory: {
			  Spoils: [5, 2]
		  }
        },
        threat: 20,
        completion: {
          skill: {
			  observation: 4,
			market: 1,
			},
			threat: -200
        },
        requirements: {
			location: ['market'],
        },
        disable: {
        },
      },	  
	  {
        name: "Buy Supplies",
        image: "supplies",
        description: "There are lots and lots of supplies for sale.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Spoils: [5, 5],
		  }
        },
        threat: 20,
        completion: {
			skill: {
				manipulation: 0.2,
			},
		  inventory: {
			  Supplies: [0, 5, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				market: 1,
			}
		},
        requirements: {
			location: ['market'],
			skill: {
				market: 3,
			}
        },
        disable: {
        },
      },
      {
        name: "Sell Supplies",
        image: "spoils",
        description: "Anyone need wood?",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Supplies: [5, 5],
		  }
        },
        threat: 20,
        completion: {
			skill: {
				manipulation: 0.2,
			},
		  inventory: {
			  Spoils: [0, 5, 0.5],
		  },
		},
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				market: 1,
			}
		},
        requirements: {
			location: ['market'],
			skill: {
				market: 5,
			}
        },
        disable: {
        },
      },
		/*
      {
        name: "Cause Distraction",
        image: "exploregrave",
        description: "",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            domination: 0.5,
			lurking: 0.5,
          },
		  inventory: {
			  Mount: [1, 5],
		  }
        },
        threat: 20,
        completion: {
			threat: -100,
		  skill: {
            domination: 0.2,
          },
        },
        requirements: {
			location: ['market'],
			skill: {
				market: 3,
			}
        },
        disable: {
        },
      },
	  */
	  /*
	  {
        name: "Listen To Sermon",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            mysticism: 0.2,
			observation: 0.8,
          },
        },
        threat: 20,
        completion: {
		  skill: {
			  temple: 1,
            observation: 1,
          },
        },
		requirements: {
			location: ['temple'],
        },
        disable: {
        },
      },	  
      {
        name: "Plan",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            brains: 1,
          },
        },
        threat: 20,
        completion: {
		  skill: {
			  brains: 1,
            temple: 1,
          },
		  threat: -200,
        },
        requirements: {
			location: ['temple'],
			skill: {
				temple: 1,
			}
        },
        disable: {
        },
      },
	  {
        name: "Proselytize",
        image: "exploregrave",
        description: "",
        time: 10,
		exp: 32,
        timeModifiers: {
          skill: {
			  manipulation: 0.5,
            mysticism: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
			  manipulation: 2,
          },
		  inventory: {
			  Support: [0, 1, 0.5]
		  }		
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				temple: 1,
			}
		},
        requirements: {
			location: ['temple'],
			skill: {
				temple: 2,
			}
        },
        disable: {
        },
      },
      {
        name: "Steal Relics",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  observation: 0.2,
			  swiftness: 0.2,
            lurking: 0.6,
          },
		  inventory: {
			  Invisibility: [1, 5]
		  }
        },
        threat: 20,
        completion: {
			skill: {
			  lurking: 1,
          },
		  inventory: {
			  Bones: [0, 25, 0.5] //Maybe change to spoils
		  }
        },
		outputModifiers: {
			skill: {
				lurking: 0.1,
				temple: 1,
			}
		},
        requirements: {
			location: ['temple'],
			skill: {
				temple: 3,
			}
        },
        disable: {
        },
      },
	*/	  
      {
        name: "Clean Shelves",
        image: "spoils",
        description: "I feel like I might get hexed just by looking at some of these items.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            swiftness: 0.5,
			thaumaturgy: 0.5,
          },
        },
        threat: 20,
        completion: {
          skill: {
				apothecary: 1,
				thaumaturgy: 4,
			},
		  inventory: {
			  Spoils: [0, 4, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				thaumaturgy: 0.25,
				apothecary: 1,
			}
		},
        requirements: {
			location: ['apothecary'],
        },
        disable: {
        },
      },
      {
        name: "Buy Shrooms",
        image: "shrooms",
        description: "Supposedly illegal, but no one seems to mind.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Spoils: [1, 5]
		  }
        },
        threat: 20,
        completion: {
			skill: {
				manipulation: 0.8,
			},
		  inventory: {
			  Shrooms: [0, 6, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				apothecary: 1,
			}
		},
        requirements: {
			location: ['apothecary'],
			skill: {
				apothecary: 3,
			}
        },
        disable: {
        },
      },
/*	  
      {
        name: "Sell Shrooms",
        image: "exploregrave",
        description: "",
        time: 1,
		exp: 32,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Shrooms: [5, 5]
		  }
        },
        threat: 20,
        completion: {
			skill: {
				manipulation: 0.2,
			},
		  inventory: {
			  Spoils: [0, 1, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				apothecary: 1,
			}
		},		
        requirements: {
			location: ['apothecary'],
			skill: {
				apothecary: 1,
			}
        },
        disable: {
        },
      },	  
	  {
        name: "Greater Mana Potion",
        image: "exploregrave",
        description: "",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
			  apothecary: 0.2,
            thaumaturgy: 0.8,
          },
          inventory: {
            Shrooms: [10, 5],
          },
        },
        threat: 20,
        completion: {
			skill: {
            thaumaturgy: 0.2,
          },
          inventory: {
			  Mana: [0, 100, 0.5],
		  }
        },
		outputModifiers: {
          skill: {
            thaumaturgy: 1,
          }
        },
        requirements: {
			location: ['apothecary'],
		  skill: {
            apothecary: 2,
          },
        },
        disable: {
        },
      },
*/	  
	  {
        name: "Potion Batch",
        image: "potions",
        description: "Using such a large cauldron is a bit unwieldy, but the results are plentiful.",
        time: 2,
		exp: 8,
        timeModifiers: {
          skill: {
			  apothecary: 0.2,
            thaumaturgy: 0.8,
          },
          inventory: {
            Shrooms: [50, 5],
          },
        },
        threat: 20,
        completion: {
			skill: {
            thaumaturgy: 1.6,
          },
          inventory: {
			  Potions: [0, 4, 0.5],
		  }
        },
		outputModifiers: {
          skill: {
            thaumaturgy: 0.25,
			apoth: 1,
          }
        },	
        requirements: {
			location: ['apothecary'],
		  skill: {
            apothecary: 5,
          },
        },
        disable: {
        },
      },
	  /*
	  {
        name: "Collect Corpse",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            might: 0.2,
			lurking: 0.8,
			midtown: 1,
          },
        },
        threat: 20,
        completion: {
		  inventory: {
			  Corpses: [1, 0, 1],
			  Spoils: [5, 0, 1],
		  },
		  threat: 250,
        },
        requirements: {
			location: ['midtown'],
			skill: {
				midtown: 5,
			}
        },
        disable: {
        },
      },
	*/	  
      {
        name: "Collection Run",
        image: "crun",
        description: "Not much running involved.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  swiftness: 0.2,
            might: 0.2,
			domination: 0.6,
          },
        },
        threat: 20,
        completion: {
          skill: {
			  domination: 4,
			cartel: 1,
			},
			//inventory: {
			  //Spoils: [0, 4, 0.5]
		  //}
        },
		/*
		outputModifiers: {
			skill: {
				domination: 0.25,
				cartel: 0.75,
			}
		},
		*/
        requirements: {
			location: ['cartel'],
        },
        disable: {
        },
      },	  
	  {
        name: "Counterfeiting",
        image: "spoils",
        description: "<Redacted>",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
			  brains: 0.5,
            thaumaturgy: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
				brains: 2,
				thaumaturgy: 2,
			},
		  inventory: {
			  Spoils: [0, 5, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				brains: 0.1,
				cartel: 1,
			}
		},
        requirements: {
			location: ['cartel'],
			skill: {
				cartel: 3,
			}
        },
        disable: {
        },
      },
      {
        name: "Corpse Disposal",
        image: "corpses",
        description: "Cleanup crew at your service.",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
			  might: 0.5,
            lurking: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
				might: 2,
				lurking: 2,
			},
		  inventory: {
			  Corpses: [1, 0, 1],
		  },
		  threat: 20,
		},
        requirements: {
			location: ['cartel'],
			skill: {
				cartel: 5,
			}
        },
        disable: {
        },
      },	  
	  // Lowtown Stuff
	  {
        name: "Go To Slums",
        image: "arrow",
        description: "Move to the Slums",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'slums',
        },
        requirements: {
			location: ['lowtown'],
          skill: {
            triangle: 1,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To Docks",
        image: "arrow",
        description: "Move to the Docks",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'docks',
        },
        requirements: {
			location: ['lowtown'],
          skill: {
            slums: 1,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To Tavern",
        image: "arrow",
        description: "Move to the Tavern",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'tavern',
        },
        requirements: {
			location: ['lowtown'],
          skill: {
            docks: 4,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To Pits",
        image: "arrow",
        description: "Move to the Pits",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'pits',
        },
        requirements: {
			location: ['lowtown'],
          skill: {
            tavern: 4,
          },
        },
        disable: {
        },
      },
      {
        name: "Back to Lowtown",
        image: "backarrow",
        description: "Move Back to Lowtown",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'lowtown',
        },
        requirements: {
			location: ['slums', 'docks', 'tavern', 'pits'],
        },
        disable: {
        },
      },
      {
        name: "Give Gifts",
        image: "support",
        description: "If it earns you goodwill, can it truly be called charity?",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Spoils: [5, 5],
		  },
        },
        threat: 20,
        completion: {
          skill: {
				slums: 1,
				manipulation: 4,
			},
		  inventory: {
			  Support: [0, 1, 0.5],
		  },
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				slums: 1,
			},
		},
        requirements: {
			location: ['slums'],
        },
        disable: {
        },
      },
      {
        name: "Lay Low",
        image: "lowerthreat",
        description: "Bundle myself up like a little homeless Lich.",
        time: 5,
		exp: 160,
        timeModifiers: {
          skill: {
            lurking: 0.5,
			slums: 0.5,
          },
		  inventory: {
			  Support: [1, 5],
		  }
        },
        threat: 20,
        completion: {
			skill: {
				lurking: 2,
			},
		  threat: -400
        },
        requirements: {
			location: ['slums'],
			skill: {
				slums: 3,
			}
        },
        disable: {
        },
      },	  
      {
        name: "Arm Agitators",
        image: "minions",
        description: "Arming peasants always turns out well, doesn't it?",
        time: 1,
		exp: 160,
        timeModifiers: {
          skill: {
			domination: 1,
          },
		  inventory: {
			  Support: [1, 5],
			  Supplies: [5, 5],
		  }
        },
        threat: 20,
        completion: {
			skill: {
				domination: 0.8,
			},
		  inventory: {
			  Minions: [5, 0, 1]
		  }
        },
        requirements: {
			location: ['slums'],
			skill: {
				slums: 5,
			}
        },
        disable: {
        },
      },	  
      {
        name: "Go Fishing",
        image: "spoils",
        description: "What good simulation doesn't include fishing?",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			observation: 0.5,
			brains: 0.5,
          },
        },
        threat: 20,
        completion: {
          skill: {
				docks: 1,
				//fish: 0.1,
			},
		  inventory: {
			  Spoils: [0, 5, 0.5],
		  },
        },
		outputModifiers: {
			skill: {
				fish: 1,
			},
		},
        requirements: {
			location: ['docks'],
        },
        disable: {
        },
      },
      {
        name: "Divine Fishing Spots",
        image: "pp",
        description: "It's like fishing in a scrying barrel.",
        time: 5,
		exp: 160,
        timeModifiers: {
          skill: {
            mysticism: 1,
          },
		  inventory: {
			  Mana: [25, 5]
		  },
        },
        threat: 20,
        completion: {
			skill: {
				fish: 1,
				mysticism: 4,
			},
        },
        requirements: {
			location: ['docks'],
			skill: {
				docks: 3,
			}
        },
        disable: {
        },
      },	  
      {
        name: "Steal Cargo",
        image: "supplies",
        description: "Just one last job...",
        time: 5,
		exp: 160,
        timeModifiers: {
          skill: {
            might: 0.5,
			lurking: 0.5,
          },
		  inventory: {
			  Support: [1, 5]
		  }
        },
        threat: 20,
        completion: {
			skill: {
				might: 2,
				lurking: 2,
			},
		  inventory: {
			  Supplies: [0, 5, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				lurking: 0.05,
				might: 0.05,
				docks: 1,
			}
		},
        requirements: {
			location: ['docks'],
			skill: {
				docks: 5,
			}
        },
        disable: {
        },
      },
	  /*
      {
        name: "Smuggle Weapons",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            might: 0.5,
			lurking: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
				lurking: 2,
			},
		  inventory: {
			  Weapons: [0, 5, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				lurking: 0.5,
				docks: 0.5,
			}
		},
        requirements: {
			location: ['docks'],
			skill: {
				docks: 3,
			}
        },
        disable: {
        },
      },
	  */
      {
        name: "Buy Drinks",
        image: "support",
        description: "A round on me!",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Spoils: [5, 5]
		  }
        },
        threat: 20,
        completion: {
			skill: {
				manipulation: 0.8,
				tavern: 1,
			},
		  inventory: {
			  Support: [0, 1, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				tavern: 1,
			}
		},
        requirements: {
			location: ['tavern'],
        },
        disable: {
        },
      },	  
      {
        name: "Gamble",
        image: "spoils",
        description: "It's an easy game when you know the cards they hold.",
        time: 1,
		exp: 32,
        timeModifiers: {
          skill: {
            brains: 1,
          },
		  inventory: {
			  Spoils: [5, 5]
		  }
        },
        threat: 20,
        completion: {
		  skill: {
			  brains: 0.8,
			  cards: 1,
			},
		  inventory: {
			  Spoils: [0, 1, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				brains: 0.1,
				cards: 1,
			},
		},
        requirements: {
			location: ['tavern'],
			skill: {
				tavern: 3,
			}
        },
        disable: {
        },
      },
	  /*
      {
        name: "Give Goods",
        image: "exploregrave",
        description: "",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            might: 1,
          },
		  inventory: {
			  Supplies: [5, 5]
		  }
        },
        threat: 20,
        completion: {
			skill: {
				might: 0.2,
			},
		  inventory: {
			  Support: [0, 1, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				tavern: 1,
			}
		},
        requirements: {
			location: ['tavern'],
			skill: {
				tavern: 2,
			}
        },
        disable: {
        },
      },
	*/	  
      {
        name: "Hire Mercenaries",
        image: "minions",
        description: "They may not be the most loyal, but they get the job done.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 0.5,
			domination: 0.5,
          },
		  inventory: {
			  Spoils: [25, 5]
		  }
        },
        threat: 20,
        completion: {
		  inventory: {
			  Minions: [0, 1, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				domination: 0.25,
				tavern: 1,
			}
		},
        requirements: {
			location: ['tavern'],
			skill: {
				tavern: 5,
			}
        },
        disable: {
        },
      },
/*	  
      {
        name: "Pawn Items",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  lurking: 0.5,
			manipulation: 0.5,
          },
		  inventory: {
			  Supplies: [1, 5]
		  }
        },
        threat: 20,
        completion: {
          skill: {
			 thieves: 1,
			manipulation: 1,
          },
		  inventory: {
			  Spoils: [0, 1, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				thieves: 1,
			},
		},
        requirements: {
			location: ['thieves'],
        },
        disable: {
        },
      },
      {
        name: "Hide Out",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			 lurking: 0.5,
			thieves: 0.5,
          },
		  inventory: {
			  Secrets: [1, 5],
		  }
        },
        threat: 20,
        completion: {
			threat: -500,
			skill: {
			 lurking: 1,
          },
		},
        requirements: {
			location: ['thieves'],
			skill: {
				thieves: 1,
			}
        },
        disable: {
        },
      },  
      {
        name: "Sell Secret",
        image: "exploregrave",
        description: "",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Secrets: [1, 5]
		  }
        },
        threat: 20,
        completion: {
		  skill: {
			manipulation: 0.2,
          },
		  inventory: {
			  Spoils: [0, 5, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				thieves: 1,
			}
		},
        requirements: {
			location: ['thieves'],
			skill: {
				thieves: 2,
			}
        },
	  },
		{
        name: "Buy Secret",
        image: "exploregrave",
        description: "",
        time: 1,
		exp: 32,
        timeModifiers: {
          skill: {
            manipulation: 1,
          },
		  inventory: {
			  Spoils: [5, 5]
		  }
        },
        threat: 20,
        completion: {
		  skill: {
			manipulation: 0.2,
          },
		  inventory: {
			  Secrets: [0, 1]
		  }
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				thieves: 1,
			}
		},
        requirements: {
			location: ['thieves'],
			skill: {
				thieves: 2,
			}
        },
        disable: {
        },
      },
      {
        name: "Craft Supplies",
        image: "exploregrave",
        description: "",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            might: 0.2,
			thaumaturgy: 0.8,
          },
		  inventory: {
			  Wood: [1, 2],
			  Shrooms: [1, 2],
		  }
        },
        threat: 20,
        completion: {
			skill: {
			thaumaturgy: 1,
          },
		  inventory: {
			  Supplies: [0, 5, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				thaumaturgy: 1,
			}
		},
        requirements: {
			location: ['thieves'],
			skill: {
				thieves: 3,
			}
        },
        disable: {
        },
      },
*/	  
      {
        name: "Watch Fights",
        image: "aa",
        description: "Sometimes it's so brutal that I can't even bear to watch.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  observation: 1,
          },
        },
        threat: 20,
        completion: {
          skill: {
			 pits: 1,
			destruction: 4,
          },
        },
        requirements: {
			location: ['pits'],
        },
        disable: {
        },
      },
      {
        name: "Duel",
        image: "spoils",
        description: "Here goes nothing.",
        time: 1,
		exp: 32,
        timeModifiers: {
          skill: {
			might: 0.4,
			destruction: 0.4,
			pits: 0.2,
          },
		  inventory: {
			  Mana: [50, 6]
		  },
        },
        threat: 20,
        completion: {
			inventory: {
			  Spoils: [0, 6, 0.5]
		  },
			skill: {
				might: 0.4,
			 destruction: 0.4,
          },
		},
		outputModifiers: {
			skill: {
				destruction: 0.25,
				pits: 1,
			}
		},
        requirements: {
			location: ['pits'],
			skill: {
				pits: 3,
			}
        },
        disable: {
        },
      },  
	  {
        name: "'Bury' Corpse",
        image: "corpses",
        description: "Or at least what's left of them.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  might: 0.5,
            lurking: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
				might: 2,
				lurking: 2,
			},
		  inventory: {
			  Corpses: [1, 0, 1],
		  },
		  threat: 20,
		},
        requirements: {
			location: ['pits'],
			skill: {
				pits: 5,
			}
        },
        disable: {
        },
      },
	  // Uptown stuff
      {
        name: "Go To Manors",
        image: "arrow",
        description: "Move to the Manors.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'manor',
        },
        requirements: {
			location: ['uptown'],
          skill: {
            triangle: 2,
          },
        },
        disable: {
        },
      },	  
	  {
        name: "Go To Barracks",
        image: "arrow",
        description: "Move to the Barracks.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'barracks',
        },
        requirements: {
			location: ['uptown'],
          skill: {
            manors: 4,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To Wizard's Watch",
        image: "arrow",
        description: "Move to Wizard's Watch.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'wizards',
        },
        requirements: {
			location: ['uptown'],
          skill: {
            barracks: 4,
          },
        },
        disable: {
        },
      },
      {
        name: "Go To Theater",
        image: "arrow",
        description: "Move to the theater.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'theater',
        },
        requirements: {
			location: ['uptown'],
          skill: {
            wizards: 4,
          },
        },
        disable: {
        },
      },	  
      {
        name: "Back to Uptown",
        image: "backarrow",
        description: "Move back to Uptown.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 1,
          },
        },
        threat: 20,
        completion: {
          location: 'uptown',
        },
        requirements: {
			location: ['manor', 'barracks', 'wizards', 'theater'],
        },
        disable: {
        },
      },
      {
        name: "Work as Servant",
        image: "spoils",
        description: "Good thing I don't have eyes to roll.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            observation: 0.2,
			brains: 0.2,
			swiftness: 0.6,
          },
        },
        threat: 20,
        completion: {
		  skill: {
            manors: 1,
			swiftness: 4,
          },
		  inventory: {
			  Spoils: [0, 5, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				swiftness: 0.1,
				manors: 1,
			}
		},
        requirements: {
			location: ['manor'],
        },
        disable: {
        },
      },  
      {
        name: "Blackmail",
        image: "spoils",
        description: "The wealthier they are, the darker their secrets.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 0.8,
			lurking: 0.2,
          },
        },
        threat: 20,
        completion: {
			skill: {
            manipulation: 1.6,
          },
		  inventory: {
			  Spoils: [0, 5, 0.5]
		  },
		  threat: 20,
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				manors: 1,
			}
		},
        requirements: {
			location: ['castle'],
			skill: {
				manors: 3,
			}
        },
        disable: {
        },
      },	
      {
        name: "Scheme",
        image: "support",
        description: "Wealth is never satisfying enough.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            manipulation: 0.8,
			lurking: 0.2,
          },
        },
        threat: 20,
        completion: {
			skill: {
            manipulation: 1.6,
          },
		  inventory: {
			  Support: [0, 1, 0.5]
		  },
		  threat: 20,
        },
		outputModifiers: {
			skill: {
				manipulation: 0.1,
				manors: 1,
			}
		},
        requirements: {
			location: ['castle'],
			skill: {
				manors: 5,
			}
        },
        disable: {
        },
      },	  
      {
        name: "Drill",
        image: "drill",
        description: "The hardest part is always getting started.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
            might: 0.8,
			swiftness: 0.2,
          },
        },
        threat: 20,
        completion: {
		  skill: {
            might: 4,
			barracks: 1,
          },
        },
        requirements: {
			location: ['barracks'],
        },
        disable: {
        },
      },
	  {
        name: "Patrol",
        image: "spoils",
        description: "I absolutely love social deduction games.",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
            swiftness: 0.2,
			might: 0.2,
			observation: 0.6,
          },
        },
        threat: 20,
        completion: {
			skill: {
            observation: 4,
          },
		  inventory: {
			Spoils: [0, 5, 0.5],  
		  },
        },
		outputModifiers: {
			skill: {
				observation: 0.1,
				barracks: 1,
			}
		},	
        requirements: {
			location: ['barracks'],
			skill: {
				barracks: 3,
			}
        },
        disable: {
        },
      },	  
	  {
        name: "Bribe Guards",
        image: "lowerthreat",
        description: "This is not the Lich you're looking for.",
        time: 1,
		exp: 8,
        timeModifiers: {
          skill: {
            barracks: 0.8,
			manipulation: 0.2,
          },
		  inventory: {
			  Spoils: [25, 5],
		  }
        },
        threat: 20,
        completion: {
			skill: {
            manipulation: 0.4,
          },
		  threat: -200,
        },
        requirements: {
			location: ['barracks'],
			skill: {
				barracks: 5,
			}
        },
        disable: {
        },
      },	 	  
      {
        name: "Advanced Classes",
        image: "class",
        description: "Isn't all of this just theoretical?",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  magic: 0.5,
			brains: 0.5,
          },
		  inventory: {
			Mana: [25, 2],  
		  },
        },
        threat: 20,
        completion: {
		  skill: {
			  magic: 4,
			wizards: 1,
          },
        },
        requirements: {
			location: ['wizards'],
        },
        disable: {
        },
      },
      {
        name: "Mana Pool",
        image: "magic",
        description: "No Swimming Allowed!",
        time: 2,
		exp: 8,
        timeModifiers: {
          skill: {
			magic: 1,
          },
		  inventory: {
			Spoils: [5, 6],  
		  },
        },
        threat: 20,
        completion: {
		  inventory: {
			  Mana: [0, 25, 0.5]
		  }
        },
		outputModifiers: {
			skill: {
				magic: 0.25,
				wizards: 1,
			}
		},
        requirements: {
			location: ['wizards'],
			skill: {
				wizards: 3,
			}
        },
        disable: {
        },
      },
/*	  
      {
        name: "Forbidden Wing",
        image: "exploregrave",
        description: "",
        time: 25,
		exp: 32,
        timeModifiers: {
          skill: {
            magic: 0.2,
			necromancy: 0.8,
          },
        },
        threat: 20,
        completion: {
			skill: {
			necromancy: 5,
          },
		  inventory: {
			  Secrets: [0, 1, 0.5]
		  },
        },
		outputModifiers: {
			skill: {
				necromancy: 1,
			}
		},
        requirements: {
			location: ['wizards'],
			skill: {
				wizards: 2,
			}
        },
        disable: {
        },
      },	
	  */
      {
        name: "Raise Dead",
        image: "minions",
        description: "It's alive!",
        time: 1,
		exp: 32,
        timeModifiers: {
          skill: {
			necromancy: 1,
          },
		  inventory: {
			  Corpses: [1, 5],
		  }
        },
		outputModifiers: {
			skill: {
				necromancy: 0.25,
				wizards: 1,
			}
		},
        threat: 20,
        completion: {
			skill: {
			necromancy: 0.8,
          },
			inventory: {
				Minions: [0, 1, 0.5]
			}
        },
        requirements: {
			location: ['wizards'],
			skill: {
				wizards: 5,
			}
        },
        disable: {
        },
      },	
      {
        name: "Stage Hand",
        image: "exploregrave",
        description: "A few of my colleagues are animated hands.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  might: 0.2,
			observation: 0.2,
			brains: 0.2,
			swiftness: 0.2,
			lurking: 0.2,
          },
        },
        threat: 20,
        completion: {
		  skill: {
			  might: 0.8,
			observation: 0.8,
			brains: 0.8,
			swiftness: 0.8,
			lurking: 0.8,
			theater: 1,
          },
        },
        requirements: {
			location: ['theater'],
        },
        disable: {
        },
      },
      {
        name: "Danse Macabre",
        image: "spoils",
        description: "The show must go on!",
        time: 5,
		exp: 8,
        timeModifiers: {
          skill: {
			necromancy: 1,
          },
		  inventory: {
			Mana: [25, 5],  
		  },
        },
        threat: 20,
        completion: {
		  inventory: {
			  Spoils: [0, 10, 0.5]
		  },
		  skill: {
			necromancy: 4,
          },
        },
		outputModifiers: {
			skill: {
				necromancy: 0.25,
				theater: 1,
			}
		},
        requirements: {
			location: ['theater'],
			skill: {
				theater: 3,
			}
        },
        disable: {
        },
      },	  
	  {
        name: "Steal Corpse",
        image: "corpses",
        description: "It seems to have taken a break.",
        time: 5,
		exp: 32,
        timeModifiers: {
          skill: {
			  might: 0.5,
            lurking: 0.5,
          },
        },
        threat: 20,
        completion: {
			skill: {
				might: 2,
				lurking: 2,
			},
		  inventory: {
			  Corpses: [1, 0, 1],
		  },
		  threat: 20,
		},
        requirements: {
			location: ['theater'],
			skill: {
				theater: 5,
			}
        },
        disable: {
        },
      },
    ];
	
	
    mapCompletion = {
		/*
      graveyard: [0, 10],
      crow: [0, 100],
      bones: [0, 100],
      forest: [0, 50],
	  swamp: [0, 50],
	  dredge: [0, 250],
	  shrooms: [0, 50],
	  critters: [0, 250],
	  school: [0, 100],
	  'class': [0, 50],
	  ww: [0, 50],
	  ee: [0, 50],
	  pp: [0, 50],
	  aa: [0, 50],
	  lan: [0, 50],
	  crypts: [0, 500],
	  lowtown: [0, 150],
	  midtown: [0, 150],
	  uptown: [0, 150],
	  docks: [0, 75],
	  tavern: [0, 75],
	  thieves: [0, 75],
	  market: [0, 75],
	  temple: [0, 75],
	  apothecary: [0, 75],
	  barracks: [0, 75],
	  wizards: [0, 75],
	  castle: [0, 75],
	  */
    };

    milestone = {
		crawl: false,
		graveyard: false,
		bones: false,
		crows: false,
		tutorial: false,
      "Evolve - Kid": false,
	  "Evolve - Teenager": false,
	  school: false,
	  evolve3: false,
	  town1: false,
	  confront: false,
	  victory: false,
    };

    skills = {
      swiftness: {
        name: "Swiftness",
        description: "Fly you fools.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "swiftness",
      },
      observation: {
        name: "Observation",
        description: "I see...",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "observation",
      },
      brains: {
        name: "Brains",
        description: "Brains...",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "brains",
      },
      might: {
        name: "Might",
        description: "Power overwhelming.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "swiftness",
      },
      lurking: {
        name: "Lurking",
        description: "Never know what hit 'em.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "swiftness",
      },
      manipulation: {
        name: "Manipulation",
        description: "This isn't the Lich you are looking for.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "brains",
      },
      magic: {
        name: "Magic",
        description: "So it begins.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "brains",
      },
	  thaumaturgy: {
		name: "Thaumaturgy",
        description: "Not quite sure what it does, but it looks cool.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "brains",
	  },
	  domination: {
		name: "Domination",
        description: "I'm the alpha.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  mysticism: {
		name: "Mysticism",
        description: "What a great aura you have.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  destruction: {
		name: "Destruction",
        description: "Make things go BOOM.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  necromancy: {
		name: "Necromancy",
        description: "Everyone's favorite school of magic.",
		category: "vice",
		base: 8.5,
        lvl: 0,
        exp: 0,
        image: "necro",
	  },
	  necropolis: {
		name: "Necropolis",
        description: "It's a graveyard.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  lichdom: {
		name: "Lichdom",
        description: "I think therefore I Lich",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  crows: {
		name: "Crow Patterns",
        description: "To catch a crow.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  forest: {
		name: "Forest",
        description: "Yeah it's haunted.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  swamp: {
		name: "Swamp",
        description: "I've got a bad feeling about this.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },	
	  critters: {
		name: "Game Trails",
        description: "It's to gamey.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  school: {
		name: "Campus",
        description: "How do these students get around?",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },	
	  'class': {
		name: "Class",
        description: "This lesson seems familiar.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "book",
	  },
	  ww: {
		name: "Wierd Weeds",
        description: "A club devoted to herbalism.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "shrooms",
	  },
	  ee: {
		name: "Equestrians for Equality",
        description: "A club devoted the fair treatment all living things.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  pp: {
		name: "Planar Problems",
        description: "A club devoted to studying and preventing the end of the world.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  aa: {
		name: "Ascendant Adventurers",
        description: "A club devoted to future adventures.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  lan: {
		name: "Live Action Necromancy",
        description: "A club devoted to roleplay and fun with friends.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  crypts: {
		name: "Crypts",
        description: "There are rats everywhere!",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  slums: {
		name: "Sleepy Slums",
        description: "The slums hosting the poor and impoverished.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  docks: {
		name: "Dusty Docks",
        description: "The docks that hosts mostly fishing vessels.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  tavern: {
		name: "Toasty Tavern",
        description: "A quaint tavern that attracts all kinds.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  pits: {
		name: "Proving Pits",
        description: "A underground dueling ring.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  triangle: {
		name: "Town Triangle",
        description: "The center of the town, partitioning the three districts.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  market: {
		name: "Market Magnific",
        description: "The local market with plenty of goods for sale.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  apothecary: {
		name: "A+ Apothecary",
        description: "A store with mysterious items for sale.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  cartel: {
		name: "Cart Collective",
        description: "The local cartel.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  manors: {
		name: "Manor Meadows",
        description: "The residential district of the wealthy.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  barracks: {
		name: "Battle Barracks",
        description: "The barracks that hosts most of the town guard.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  wizards: {
		name: "Wizard's Watch",
        description: "An advanced magical academy for adults.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },
	  theater: {
		name: "Twisted Theater",
        description: "A secret society of the arts using the undead.",
		category: "map",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },	
	  cards: {
		name: "Cards",
        description: "I swear I'm not looking.",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },	
	  fish: {
		name: "Fish",
        description: "I have got you now!",
		category: "knowledge",
		base: 1,
        lvl: 0,
        exp: 0,
        image: "swiftness",
	  },	  
    }

    threat = 0;
    power = 100;
    lives = 0;
	totalLives = 0;
    enableRepeat = false;
    repeat = false;
    enableRestart = false;
    restart = false;
	gameBeaten = false;
	prestigeAmount = 0;
    enableLocations = false;
    location = 'graveyard';
	form = 'baby';

    codeIndex = this.code.length;
	
	assistance = false;

    inventory = {
    }
	
	async prestige() {
		this.prestigeAmount += 1;
		
		let keys = Object.keys(this.milestone);
	    for (let i = 0; i < keys.length; i++) {
			this.milestone[keys[i]] = false; 
	    }
		keys = Object.keys(this.skills);
	    for (let i = 0; i < keys.length; i++) {
			this.skills[keys[i]].lvl = 0; 
			this.skills[keys[i]].exp = 0;
	    }
		keys = Object.keys(this.messages);
	    for (let i = 0; i < keys.length; i++) {
			this.messages[keys[i]].completed = false; 
	    }
		
		this.code = [];
		this.codeIndex = 0;
		this.lives = 0;
		this.log = [];
		
		this.homeScreen.loadRefresh();
		if (this.optionsScreen) {
			this.optionsScreen.loadRefresh();
		}
		await AsyncStorage.multiRemove(['lb-life-A','lb-life-B','lb-life-C']);
	}
	
	beatGame() {
		this.gameBeaten = true;
		if (this.optionsScreen) {
			this.optionsScreen.loadRefresh();
		}
	}
	
	resetInventory() {
		this.inventory = {};
		//if (this.skills.magic.lvl > 0) {
			//this.inventory.Mana = this.skills.magic.lvl * 0;
		//}
    }

    resetIndex() {
      this.codeIndex = this.code.length;
    }

    getExpToNextLvl(skill) {
      //return Math.floor(10*Math.pow(this.skills[skill].lvl+1, 1.5));
	  //return Math.floor(10*Math.pow(this.skills[skill].lvl+1, 1.1));
	  return Math.floor(Math.pow(this.skills[skill].base+this.skills[skill].lvl, 1.1));
    }
	
	getTime(scheme) {
		let time = scheme.time;
		
		let keys = [];
		let ogTime = time;
		/*
		if (scheme.timeModifiers.map) {
		  keys = Object.keys(scheme.timeModifiers.map);
		  let mod = 0;
		  for (let i = 0; i < keys.length; i++) {
			// 2 / (1+x) because negative bad
			//time /= Math.pow(scheme.timeModifiers.map[keys[i]], this.getMapPercent(keys[i])-1);
			time *= scheme.timeModifiers.map[keys[i]] * Math.pow(scheme.timeModifiers.map[keys[i]], this.getMapPercent(keys[i])*-1);
		  }
		  //mod += 1;
		  //time *= mod;
		}
		*/

		ogTime = time;
		if (scheme.timeModifiers.skill) {
		  keys = Object.keys(scheme.timeModifiers.skill);
		  let mod = 0;
		  for (let i = 0; i < keys.length; i++) {
			// skills start at x1
			mod += (this.getSkillMod(keys[i]) - 1) * scheme.timeModifiers.skill[keys[i]];
		  }
		  mod += 1;
		  time /= mod;
		}
		

		//ogTime = time;
		if (scheme.timeModifiers.inventory) {
		  keys = Object.keys(scheme.timeModifiers.inventory);
		  for (let i = 0; i < keys.length; i++) {
			if (!(this.inventory[keys[i]])) {
				time *= scheme.timeModifiers.inventory[keys[i]][1];
			  continue;
			}
			else if (this.inventory[keys[i]] < scheme.timeModifiers.inventory[keys[i]][0]) {
				//time *= 1 + (scheme.timeModifiers.inventory[keys[i]][1] - 1) * (1 - this.inventory[keys[i]] / scheme.timeModifiers.inventory[keys[i]][0]); //linear
				time *= 1 + scheme.timeModifiers.inventory[keys[i]][1] - Math.pow(scheme.timeModifiers.inventory[keys[i]][1], this.inventory[keys[i]] / scheme.timeModifiers.inventory[keys[i]][0]);
				//let a = scheme.timeModifiers.inventory[keys[i]][1]-1;
				//time /=  1 + a * Math.pow(this.inventory[keys[i]]/scheme.timeModifiers.inventory[keys[i]][0],1+a);
			}
			//else {
				//let a = scheme.timeModifiers.inventory[keys[i]][1]-1;
				//time /= 1 + a * Math.pow(this.inventory[keys[i]]/scheme.timeModifiers.inventory[keys[i]][0],1/(1+a));
				//time /= scheme.timeModifiers.inventory[keys[i]][1];
			//}
		  }
		}
		
		//return time;

		// Calculate Regression
		let schemeCount = this.getSchemeCount(scheme.name);
		let regression = Math.pow(2, schemeCount/10);
		//let regression = Math.pow(schemeCount/10, 2) + 1;
		let dread = 1 // Math.pow((this.getPower()-100)/1000 + 1, 0.1);
		time *= regression * dread;
		return time;
	}
	
	liveLife() {
		this.resetInventory();
		this.wipeTimesDone();
		this.form = 'baby';
		let actionTime = 0;
		let tempThreat = 0;
		let finish = false;
		for (let i = 0; i < this.code.length; i++) {
			for (let j = 0; j < this.code[i].count; j++) {
				actionTime = this.getTime(this.code[i].action)
				tempThreat += actionTime * this.code[i].action.threat;
				if (tempThreat > this.getPower()) {
					finish = true;
					break;
				}
				this.complete(this.code[i].action);
				this.code[i].timesDone += 1;
				if (this.code[i].action.completion.threat) {
					tempThreat += this.code[i].action.completion.threat
				}
				if (tempThreat > this.getPower()) {
					finish = true;
					break;
				}
				if (i+1 == this.code.length && this.repeat) {
					j--
				}
			}
			if (finish) {
				break;
			}
		}
		this.resetInventory();
		this.wipeTimesDone();
		this.form = 'baby';
		this.life += 1;
	}
	
	getMyEstimate(toCount) {
		this.resetInventory();
		this.wipeTimesDone();
		this.form = 'baby';
		let totalTime = 0;
		let actionTime = 0;
		let tempThreat = 0;
		let finish = false;
				
		if (this.code[toCount-1].savedThreat
				&& this.code[toCount-1].savedThreat.count == this.code[toCount-1].count
				&& this.code[toCount-1].savedThreat.codeNumber == toCount-1) {
			if (this.code[toCount-1].savedThreat.inventory) {
				this.inventory = {...this.code[toCount-1].savedThreat.inventory};
			}
			return this.code[toCount-1].savedThreat.threatPercent;
		}
		
		for (let i = 0; i < toCount; i++) {
			
			if (this.code[i].savedThreat && this.code[i].savedThreat.codeNumber == i &&this.code[i].savedThreat.count == this.code[i].count) {
				tempThreat = this.code[i].savedThreat.threat;
				if (this.code[i].savedThreat.inventory) {
					this.inventory = {...this.code[i].savedThreat.inventory};
				}
				this.form = this.code[i].savedThreat.form;
				this.code[i].timesDone = this.code[i].savedThreat.count;
				continue;
			}
			
			for (let j = 0; j < this.code[i].count; j++) {
				actionTime = this.getTime(this.code[i].action)
				//totalTime += actionTime;
				tempThreat += actionTime * this.code[i].action.threat;
				if (tempThreat > this.getPower()) {
					//totalTime -= (tempThreat - this.getPower()) / this.code[i].action.threat;
					finish = true;
					break;
				}
				this.fauxComplete(this.code[i].action);
				this.code[i].timesDone += 1;
				if (this.code[i].action.completion.threat) {
					tempThreat = Math.max(tempThreat + this.code[i].action.completion.threat, 0)
				}
				if (tempThreat > this.getPower()) {
					finish = true;
					break;
				}
				if (i+1 == this.code.length && this.repeat && this.canIncremenet(this.code[i].action)) {
					//j--
				}
			}
			
			if (finish) {
				break;
			}
		}
		
		let returnValue = Math.max(Math.min(tempThreat / this.getPower(), 1), 0);
		
		let save = false;
		if (this.code[toCount-1].savedThreat == null) {
			save = true
		}
		else if (this.code[toCount-1].savedThreat.count != this.code[toCount-1].count
				|| this.code[toCount-1].savedThreat.codeNumber != toCount-1) {
			save = true
		}
		if (save) {
			this.code[toCount-1].savedThreat = {threat: tempThreat, threatPercent: returnValue,
												count: this.code[toCount-1].count, codeNumber: toCount-1,
												inventory: {...this.inventory}, form: this.form}
			for (let i = toCount; i < this.code.length; i++) {
				this.code[i].savedThreat = null;
			}
		}
		
		//console.log(returnValue, tempThreat, this.getPower());
		//this.resetInventory();
		this.wipeTimesDone();
		this.form = 'baby';
		return returnValue;		
	}

	estimateLifeTime() {
		this.resetInventory();
		this.wipeTimesDone();
		this.form = 'baby';
		let totalTime = 0;
		let actionTime = 0;
		let tempThreat = 0;
		let finish = false;
		for (let i = 0; i < this.code.length; i++) {
			for (let j = 0; j < this.code[i].count; j++) {
				actionTime = this.getTime(this.code[i].action)
				totalTime += actionTime;
				tempThreat += actionTime * this.code[i].action.threat;
				if (tempThreat > this.getPower()) {
					totalTime -= (tempThreat - this.getPower()) / this.code[i].action.threat;
					finish = true;
					break;
				}
				this.fauxComplete(this.code[i].action);
				this.code[i].timesDone += 1;
				if (this.code[i].action.completion.threat) {
					tempThreat = Math.max(tempThreat + this.code[i].action.completion.threat, 0)
				}
				if (tempThreat > this.getPower()) {
					finish = true;
					break;
				}
				if (i+1 == this.code.length && this.repeat && this.canIncremenet(this.code[i].action)) {
					j--
				}
			}
			if (finish) {
				break;
			}
		}
		this.resetInventory();
		this.wipeTimesDone();
		this.form = 'baby';
		return totalTime;
	}
	
	fauxComplete(scheme) {
		this.inventoryComplete(scheme);
		if (scheme.completion.form) {
			this.form = scheme.completion.form
		}
	}
	
	inventoryComplete(scheme) {
		let keys = {}
		if (scheme.completion.inventory) {
		  let mod = 0;
		  if (scheme.outputModifiers) {
			  /*
			if (scheme.outputModifiers.map) {
			  keys = Object.keys(scheme.outputModifiers.map);
			  for (let i = 0; i < keys.length; i++) {
				mod *= this.getMapPercent(keys[i]) * scheme.outputModifiers.map[keys[i]];
			  }               
			}
			*/
			if (scheme.outputModifiers.skill) {
			  keys = Object.keys(scheme.outputModifiers.skill);
			  for (let i = 0; i < keys.length; i++) {
				mod += this.skills[keys[i]].lvl * scheme.outputModifiers.skill[keys[i]];
				  
				//mod *= this.getSkillMod(keys[i]) * scheme.outputModifiers.skill[keys[i]];
				//mod *= (this.getSkillMod(keys[i]) - 1) * scheme.outputModifiers.skill[keys[i]] + 1;
			  }               
			}
		  }

		  keys = Object.keys(scheme.completion.inventory);
		  for (let i = 0; i < keys.length; i++) {
			if (!(this.inventory[keys[i]])) {
			  this.inventory[keys[i]] = 0;
			}
			
			if (scheme.completion.inventory[keys[i]][2]) {
				this.inventory[keys[i]] += scheme.completion.inventory[keys[i]][0] + Math.floor(scheme.completion.inventory[keys[i]][1] * Math.pow(mod, scheme.completion.inventory[keys[i]][2]));
			}
			//else {
				//this.inventory[keys[i]] += scheme.completion.inventory[keys[i]][0] + Math.floor(scheme.completion.inventory[keys[i]][1] * mod);
			//}
		  }
		}	

	  if (scheme.timeModifiers.inventory) {
		keys = Object.keys(scheme.timeModifiers.inventory);
		for (let i = 0; i < keys.length; i++) {
			if (this.inventory[keys[i]]) {
				this.inventory[keys[i]] = Math.max(this.inventory[keys[i]] - scheme.timeModifiers.inventory[keys[i]][0], 0);
			}
		}
	  }		
	}

    complete(scheme, percent) {
      let completion = scheme.completion;
      let returnData = [];

      let skip = false;
      if (percent) {
        skip = true;
      }
      else {
        percent = 1;
      }

      let keys = [];
	  /*
      if (scheme.timeModifiers.skill) {
        keys = Object.keys(scheme.timeModifiers.skill);
        for (let i = 0; i < keys.length; i++) {
          let expToNextLvl = this.getExpToNextLvl(keys[i]);
          this.skills[keys[i]].exp += scheme.timeModifiers.skill[keys[i]]*scheme.exp * percent;
          while (expToNextLvl - this.skills[keys[i]].exp < MYEPSILON) {
            this.skills[keys[i]].exp -= expToNextLvl;
            this.skills[keys[i]].lvl += 1;
			
			expToNextLvl = this.getExpToNextLvl(keys[i]);

            returnData.push({name: this.skills[keys[i]].name, image: this.skills[keys[i]].image});
          }
        }
      }
	  */
	  
      keys = [];
      if (completion.skill) {
        keys = Object.keys(completion.skill);
        for (let i = 0; i < keys.length; i++) {
          let expToNextLvl = this.getExpToNextLvl(keys[i]);
          this.skills[keys[i]].exp += completion.skill[keys[i]];
          while (expToNextLvl - this.skills[keys[i]].exp < MYEPSILON) {
            this.skills[keys[i]].exp = Math.max( this.skills[keys[i]].exp - expToNextLvl, 0);
            this.skills[keys[i]].lvl += 1;
			
			expToNextLvl = this.getExpToNextLvl(keys[i]);
			
			this.code[0].savedThreat = null;

            returnData.push({name: this.skills[keys[i]].name, image: this.skills[keys[i]].image});
          }
        }
      }	  
	  
	  if (this.skillScreen) {
		  this.skillScreen.setState({refresh: !this.skillScreen.state.refresh});
	  }

      if (completion.milestone) {
        this.milestone[completion.milestone] = true;
      }
	  
      if (completion.form) {
        this.form = completion.form;
      }

      if (!skip) {
        this.inventoryComplete(scheme);
      }
	  
      if (completion.map) {
        this.mapCompletion[completion.map][0] += 1 * percent;
      }	  

      return returnData;
    }

    meetDisable(disable) {
      if (Object.keys(disable).length == 0) {
        return false;
      }
      else {
        return this.meetRequirments(disable);
      }
    }

    meetRequirments(requirements) {
      let keys;
      if (requirements.map) {
        keys = Object.keys(requirements.map);
        for (let i = 0; i < keys.length; i++) {
          if (this.mapCompletion[keys[i]][0] < requirements.map[keys[i]]) {
            return false;
          }
        }
      } 

      if (requirements.milestone) {
        if (!this.milestone[requirements.milestone]) {
          return false;
        }
      }

      if (requirements.skill) {
        keys = Object.keys(requirements.skill);
        for (let i = 0; i < keys.length; i++) {
          if (this.skills[keys[i]].lvl < requirements.skill[keys[i]]) {
            return false;
          }
        }
      }

      if (requirements.location) {
        let location = this.getLocation();
        if (!requirements.location.includes(location)) {
          return false;
        }
      }
	  
      if (requirements.form) {
        let form = this.getForm();
        if (form !== requirements.form) {
          return false;
        }
      }
	  
	  if (requirements.notform) {
        let form = this.getForm();
        if (form === requirements.notform) {
          return false;
        }
      }
	  
	  if (requirements.flag) {
        if (this.hasFlag(requirements.flag)) {
          return false;
        }
      }
	  
      return true;
    }

    getLocation() {
      let location = this.location;
      for (let i = 0; i < this.codeIndex && i < this.code.length ; i++) {
        if (this.code[i].action.completion && this.code[i].action.completion.location) {
          location = this.code[i].action.completion.location;
        }
      }
      return location;
    }
	
	getForm() {
      let form = this.form;
      for (let i = 0; i < this.codeIndex && i < this.code.length ; i++) {
        if (this.code[i].action.completion && this.code[i].action.completion.form) {
          form = this.code[i].action.completion.form;
        }
      }
      return form;
    }
	
	hasFlag(flag) {
      for (let i = 0; i < this.codeIndex && i < this.code.length ; i++) {
        if (this.code[i].action.requirements && this.code[i].action.requirements.flag) {
          this.code[i].action.requirements.flag == flag;
		  return true;
        }
      }
      return false;
    }

    checkForMessage() {
      for (let i = 0; i < this.messages.length; i++) {
        if ((this.prestigeAmount == 0 || (this.prestigeAmount > 0 && !this.messages[i].prestigeSkip)) && !this.messages[i].completed && this.meetRequirments(this.messages[i].requirements)) {
          this.messages[i].completed = true;
          this.log.push({life: this.lives, title:this.messages[i].title, text: this.messages[i].text, image: this.messages[i].image});
		  if (this.logScreen) {
			this.logScreen.setState({refresh: !this.logScreen.state.refresh});
		  }
		  if (this.objectiveScreen) {
			  this.objectiveScreen.setState({refresh: !this.objectiveScreen.state.refresh});
		  }
          return(this.messages[i]);
        }
      }
      return null;
    }

    getMaxAmount(scheme) {
      if (!(scheme.amount)) {
        return 0; // SHOULD NEVER BE HIT
      }
      let maxAmount = 0;
      let keys = Object.keys(scheme.amount);
      for (let i = 0; i < keys.length; i++) {
        maxAmount += Math.floor(Math.min(this.mapCompletion[keys[i]][0], this.mapCompletion[keys[i]][1]) / scheme.amount[keys[i]]);
      }
      return maxAmount;
    }

    canIncremenet(scheme) {
      /*
      if (!(scheme.amount)) {
        return true;
      }
      let maxAmount = this.getMaxAmount(scheme);
      let schemeCount = 0;
      for (let i = 0; i < this.code.length; i++) {
        if (this.code[i].action.name == scheme.name) {
          schemeCount += this.code[i].count;
          if (schemeCount >= maxAmount) {
            return false;
          }
        }
      } 
      */
      if (scheme.completion && (scheme.completion.location || scheme.completion.form)) {
        return false;
      }
	  if (scheme.requirements && scheme.requirements.flag) {
        return false;
      }
      return true;
    }

    getSchemeCount(schemeName) {
      let count = 0;
      for (let i = 0; i < this.code.length; i++) {
        if (this.code[i].action.name == schemeName) {
          count += this.code[i].timesDone;
        }
      } 
      return count;
    }

    getStartingPower() {
      let startingPower = this.power + this.prestigeAmount*5;
      
	  let keys = Object.keys(this.skills);
      for (let i = 0; i < keys.length; i++) { 
        startingPower += this.skills[keys[i]].lvl * 0;
      }
	  
      return startingPower;
    }

    getPower() {
      let power = this.getStartingPower();
      if (this.inventory.Bones) {
        power += this.inventory.Bones * 5;
      }
	  if (this.inventory.Blood) {
        power += this.inventory.Blood * 0;
      }
	  if (this.inventory.Mana) {
        power += this.inventory.Mana * 0;
      }
	  if (this.inventory.Minions) {
        power += this.inventory.Minions * 0;
      }
	  
	  if (this.form == 'kid') {
        power += 100;
      }
	  if (this.form == 'teen') {
        power += 500;
      }
	  if (this.form == 'youngAdult') {
        power += 2000;
      }
	  
      return power;
    }
	
	timePassed = 0;
	//baseThreat = 100/(15*Math.pow(2, 4/60 + 2)/Math.log(2) - 15*4/Math.log(2)); //60 secs base 4
	//baseThreat = 100/(15*Math.pow(2, 4/30 + 1)/Math.log(2) - 15*2/Math.log(2)); // 30 secs, base 4
	baseThreat = 100/(15*Math.pow(2, 1/30 + 1)/Math.log(2) - 15*2/Math.log(2)); // 30 secs, base 1
	getThreat(scheme, schemeDuration) {
		//let baseThreat = scheme.threat;
		let baseThreat = 20 + this.prestigeAmount;
		if (this.form == 'kid') {
			baseThreat *= 1;
		}
		else if (this.form == 'teen') {
			baseThreat *= 1;
		}
		
		return baseThreat*schemeDuration;
		//console.log(this.baseThreat);
		//let timeDuration = (15*Math.pow(2, (this.timePassed+schemeDuration)/60 + 2)/Math.log(2) - 15*4/Math.log(2)) - (15*Math.pow(2, (this.timePassed)/60 + 2)/Math.log(2) - 15*4/Math.log(2)); // 60 secs
		let timeDuration = (15*Math.pow(2, (this.timePassed+schemeDuration)/30 + 1)/Math.log(2) - 15*2/Math.log(2)) - (15*Math.pow(2, (this.timePassed)/30 + 1)/Math.log(2) - 15*2/Math.log(2)); // 30 secs
		this.timePassed += schemeDuration;
		//console.log(baseThreat, this.baseThreat, timeDuration, this.timePassed, schemeDuration)
		return this.baseThreat*timeDuration;
	}

    wipeTimesDone() {
      for (let i = 0; i < this.code.length; i++) {
          this.code[i].timesDone = 0;
      } 
    }

    getMapPercent(map) {
      return Math.pow(this.mapCompletion[map][0] / this.mapCompletion[map][1], 0.5);
    }
	
	getPartialMap(map, timesDone) {
		return Math.pow(timesDone / this.mapCompletion[map][1], 0.5);
	}

    getSkillMod(skill) {
      //return Math.pow(this.skills[skill].lvl/100 + 1, 0.5);
	  return Math.pow(this.skills[skill].lvl/33 + 1, 0.5);
    }
	
	getSkillLvl(skill) {
      //return Math.pow(this.skills[skill].lvl/100 + 1, 0.5);
	  return this.skills[skill].lvl;
    }
	
	async storeData(value) {
		try {
			const jsonValue = JSON.stringify(value)
			await AsyncStorage.setItem('lich-baby', jsonValue)
		}
		catch (e) {
			console.log(e)
		}
	}
	
	
	async getData() {
		try {
			const jsonValue = await AsyncStorage.getItem('lich-baby');
			return jsonValue != null ? JSON.parse(jsonValue) : null;
		}
		catch(e) {
			console.log(e)
		  }
	}
	
	async loadGame() {
		let saveData = await this.getData();
		if (saveData) {
			if (saveData.version && saveData.version != this.version) {
				return;
			}			
			this.code = this.loadCode(saveData.code);
			//this.loadMapCompletion(saveData.mapCompletion);
			this.loadSkills(saveData.skills);
			this.lives = saveData.lives;
			this.totalLives = saveData.totalLives;
			this.enableRepeat = saveData.enableRepeat;
			this.repeat = saveData.repeat;
			this.enableRestart = saveData.enableRestart;
			this.restart = saveData.restart;
			this.milestone = saveData.milestone;
			this.log = this.loadLog(saveData.log);
			this.loadMessages(saveData.messages);
			this.idCount = saveData.idCount;
			this.assistance = saveData.assistance;
			this.gameBeaten = saveData.gameBeaten;
			this.prestigeAmount = saveData.prestigeAmount;
		}
	}
	
	async saveGame() {
		let saveData = {
			code: this.code,
			//mapCompletion: this.getMapCompletion(),
			skills: this.getSkillData(),
			lives: this.lives,
			totalLives: this.totalLives,
			enableRepeat: this.enableRepeat,
			repeat: this.repeat,
			enableRestart: this.enableRestart,
			restart: this.restart,
			milestone: this.milestone,
			log: this.log,
			messages: this.getMessageData(),
			idCount: this.idCount,
			assistance: this.assistance,
			//time: new Date().getSeconds(),
			version: this.version,
			
			gameBeaten: this.gameBeaten,
			prestigeAmount: this.prestigeAmount,
		}
		await this.storeData(saveData);
		await this.saveAwayTime();
		console.log("SavedGame");
	}
	
	async getEncodedSave() {
		await this.saveGame();
		const jsonValue = await AsyncStorage.getItem('lich-baby')
		return base64.encode(jsonValue);
	}
	
	async importSaveData(userInput) {
		const oldJson = await AsyncStorage.getItem('lich-baby')
		let returnResult = false;
		try {
			await AsyncStorage.clear();
			const newJson = base64.decode(userInput);
			let saveData = newJson != null ? JSON.parse(newJson) : null;
			await this.storeData(saveData);
			this.loadGame();
			returnResult = true;
		}
		catch(e) {
			try {
				await AsyncStorage.setItem('lich-baby', oldJson)
			}
			catch (e) {
				console.log(e)
			}
		}
		return returnResult;
	}
	
	async saveAwayTime() {
		await AsyncStorage.setItem('lb-awayTime', JSON.stringify(Math.floor(Date.now()/1000)))
	}
	
	async getAwayTime() {
		const jsonValue = await AsyncStorage.getItem('lb-awayTime')
		this.awayTime = Number(jsonValue)
	}
	
	async saveLife(key) {
		await AsyncStorage.setItem('lb-life-'+key, JSON.stringify(this.code));
	}
	
	async loadLife(key) {
		const jsonValue = await AsyncStorage.getItem('lb-life-'+key)
		this.code = jsonValue != null ? this.loadCode(JSON.parse(jsonValue)) : [];
		this.resetIndex();
		await this.homeScreen.loadRefresh();
	}
	
	async wipeData() {
		await AsyncStorage.clear();
		console.log("WipeGame");
	}
	
	loadCode(savedCode) {
		//return [];
	  let newCode = [];
      for (let i = 0; i < savedCode.length; i++) {
		  for (let j = 0; j < this.actions.length; j++) {
			  if (this.actions[j].name == savedCode[i].action.name) {
				  newCode.push({
					  action: this.actions[j],
					  count: savedCode[i].count,
					  id: this.getId(),
				  });
				  break;
			  }
		  }
	  }

      return newCode;		
	}
	
	loadLog(saveLog) {
		let newLog = [];
		for (let i = 0; i < saveLog.length; i++) {
		  for (let j = 0; j < this.messages.length; j++) {
			  if (this.messages[j].title == saveLog[i].title) {
				  newLog.push(this.messages[j]);
				  if (saveLog[i].life != null) {
					  newLog[newLog.length-1].life = saveLog[i].life;
				  }
				  else {
					  newLog[newLog.length-1].life = 0;
				  }
				  break;
			  }
		  }
	  }
	return newLog;
	}
	
	getMapCompletion() {
		let map = {};
		let keys = Object.keys(this.mapCompletion);
		for (let i = 0; i < keys.length; i++) {
			map[keys[i]] = this.mapCompletion[keys[i]][0];
		} 
		return map;
		
	}
	
	loadMapCompletion(mapData) {
		let keys = Object.keys(mapData);
		for (let i = 0; i < keys.length; i++) {
			this.mapCompletion[keys[i]][0] = mapData[keys[i]];
		}
	}
	
	getSkillData() {
		let skills = {};
		let keys = Object.keys(this.skills);
		for (let i = 0; i < keys.length; i++) {
			skills[keys[i]] = {};
			skills[keys[i]].lvl = this.skills[keys[i]].lvl;
			skills[keys[i]].exp = this.skills[keys[i]].exp;
		} 
		return skills;
	}
	
	loadSkills(skillData) {
		let keys = Object.keys(skillData);
		for (let i = 0; i < keys.length; i++) {
			this.skills[keys[i]].lvl = skillData[keys[i]].lvl;
			this.skills[keys[i]].exp = skillData[keys[i]].exp;
		}
	}
	
	getMessageData() {
		let messages = {};
		for (let i = 0; i < this.messages.length; i++) {
			//messages[this.messages[i].title].completed = this.messages[i].completed;
			messages[this.messages[i].title] = this.messages[i].completed;
		} 
		return messages;
	}
	
	loadMessages(messageData) {
		for (let i = 0; i < this.messages.length; i++) {
			this.messages[i].completed = messageData[this.messages[i].title];
		}
	}

    messages = [
	   {
        title: "Lich Baby",
        text: "You are a Lich. A powerful evil entity capable of great destruction. Except you are also a baby. A Lich Baby.",
        image: "lichbabybw",
        requirements: {
        },
        completed: false,
      },
	  {
        title: "How to Live",
        text: "To begin, press 'Scheme' to open the Scheme Menu. Select a scheme to incorporate it into your life. When you are ready to live press 'Rise'.  If you need to conclude early, simply hold down.",
        image: null,
        requirements: {
        },
		prestigeSkip: true,
        completed: false,
      },
      {
        title: "Short Lived",
        text: "I crawl, inch by inch, to see what is around me. I find myself in a necropolis, an immense cemetery. Soon after I notice this, malevolent crows descend on me and tear me apart. I am reborn - reborn right where I began last time.\n\nYour Threat on this world rises as you live your life. Dread is a measure of your power and fear you exert on the world. When your Threat exceeds your Dread the world takes action and you are ... reborn.",
        image: null,
		//objectives: {
		//},
        requirements: {
          //milestone: 'crawl',
		  skill: {
			necropolis: 1,  
		  },
        },
        completed: false,
		//gameEnd: true,
        //tutorial1: true,
      },
      {
        title: "Baby Steps",
        //text: "I think I am getting the hang of crawling around. I should start exploring this necropolis and find my phylactery.\n\nAs you complete Schemes, you will level up Vices and other attributes that will improve and unlock more Schemes.",
        text: "I think I am getting the hang of crawling around.\n\nAs you complete Schemes, you will level up Vices and other attributes that will improve and unlock more Schemes.",
		image: null,
		objectives: {
			milestone: 'crawl',
		},
		requirements: {
          skill: {
            swiftness: 1,
          },
        },
        completed: false,
      },
      {
        title: "Time Flies",
        text: "Hmm, this may take awhile.\n\nUse 'Auto Restart' to automatically restart your life with the same schemes. Disable 'Auto Restart' and wait for your life to finish to change up your Schemes. Use 'Repeat Last' to automatically repeat the last scheme in your queue. You can disable this mid life.",
        image: null,
		requirements: {
          //milestone: 'graveyard',
		  skill: {
			necropolis: 2,  
		  },
		},
        completed: false,
        tutorial2: true,
      },
      {
        title: "My Phylactery",
        text: "Hmmmm, I can't seem to find my phylactery, the vessel holding my soul. I can't be destroyed unless it is destroyed as well. Maybe it is for the best it is well hidden.\n\nI should start looking for a way out.",
        image: "phy",
        objectives: {
			//skill: {
            //swiftness: 1,
          //},
		},
		requirements: {
          skill: {
            necropolis: 3,
          },
        },
        completed: false,
      },
	  /*
      {
        title: "Tombs",
        text: "There are a lot of Tomstone and a few Mausoleums here. Maybe I can learn something about this place, or about my phylactery's location.",
        image: null,
		objectives: {
			skill: {
				swiftness: 1,
			},
		},
		requirements: {
          skill: {
            observation: 2,
          },
        },
        completed: false,
      },
	  */
	  /*
      {
        title: "Mausoleum",
        text: "I am reborn near an unusually plain mausoleum. Maybe my phylactery is in there. The door won't budge though. There is mysterious writing on the door. I can't make skulls or tailbones of it. Until I can figure it out I should find a way out of this place.\n\nNew Schemes can be unlock by leveling up Vices and other attributes. You can look at the Ambitions Tab to see major goals.",
        image: null,
		requirements: {
          skill: {
            observation: 1,
          },
        },
        completed: false,
      },
	  */
	  /*
	  {
        title: "Decipher Door",
        text: "I should try dechipering the mausoleum door",
        image: null,
		objectives: {
			skill: {
				observation: 1, //temp
			},
		},
		requirements: {
          skill: {
            brains: 30,
          },
        },
        completed: false,
      },
	  */
      {
        title: "Walled Graveyard",
        text: "Encircling the graveyard stands a stone wall. It can't be completely enclosed though. Much like this graveyard, my memories seem to be sealed off as well. All I know is the knowledge of my Lich nature and the existence of my missing phylactery.",
        image: null,
		requirements: {
          skill: {
            necropolis: 4,
          },
        },
        completed: false,
      },
      {
        title: "Gated Graveyard",
        text: "I found the way out - an imposing gate on the far end. There appears to be a mechanism at the top that will allow passage, but I am too short to reach it. Curse this tiny body.\n\nThat's right! I can evolve my form, I think. I don't quite remember the process... Maybe reading some of these tombstones will provide insights.",
        image: "gate",
		objectives: {
			skill: {
				necropolis: 3,
			},
		},
		requirements: {
          skill: {
            necropolis: 5,
          },
        },
        completed: false,
      },
      {
        title: "The Crows",
        text: "It's difficult making any progress with these crows after me. I should observe them and see if I can come up with something.",//\n\nThere are different kinds of skills you can progress in. Vices aid in many Schemes across all areas. Maps aid in Schemes in matching locations. Knowledge is usually relevant to very specific Schemes.",
        image: "crowslog",
		objectives: {
			skill: {
				necropolis: 5,
			},
		},
		requirements: {
          skill: {
            necropolis: 6,
          },
        },
        completed: false,
      },	
	  
      {
        title: "Look and See",
        text: "They are majestic creatures, until they poke at my eye sockets.",
        image: null,
		requirements: {
          skill: {
            crows: 1,
          },
        },
        completed: false,
      },
      {
        title: "Muddy Pool",
        text: "I notice they stay from the muddy areas of the graveyard. Perhaps if I coat myself in mud, they will lose track of me. Looks fun, besides.\n\nSome Schemes like the new 'Play in Mud' scheme will decrease your threat on completion, greatly extending your life time. However, other Schemes may increase Threat upon completion. Repeated use of a Scheme in one life will increase its time to complete.",
        image: null,
		requirements: {
          skill: {
            crows: 2,
          },
        },
        completed: false,
      },
      {
        title: "Flight Patterns",
        text: "The crows seems to fly in the same route every time I am reborn. They are stuck in a loop. Quite peculiar. I think I can find a way to take advantage of this.",
        image: null,
		requirements: {
          skill: {
            crows: 3,
          },
        },
        completed: false,
      },	  
      {
        title: "Turn the Tide",
        text: "I spot a crow landing, fishing for worms, isolated from the rest, vulnerable. This should be my opportunity to ambush it.\n\nYou can hold press on a Scheme to view more information on it.",
        image: null,
		objectives: {
			skill: {
				necropolis: 6,
			},
		},
		requirements: {
          skill: {
            crows: 4,
          },
        },
        completed: false,
      },	  
      {
        title: "Prison?",
        text: "This place isn't an ordinary graveyard. It seems to be built to keep souls locked in. It has me trapped, for now...",
		requirements: {
			skill: {
				lichdom: 1,
			},
        },
        completed: false,
      },
      {
        title: "Evil Entities",
        text: "A lot of these tombs refer to beings of immense power that musn't escape at all costs. Could I be one of them?",
		requirements: {
			skill: {
				lichdom: 2,
			},
        },
        completed: false,
      },	  
      {
        title: "Way of the Lich",
        text: "Lots of talk of gloom and doom. Reducing cities to Bones and Ash. Bones? Bones. Bones! Yes, I need bones. Evolution requires a lot bones. How convenient, I am in a graveyard. Time to go gravedigging. I think I am still missing something though.",
		objectives: {
			skill: {
            necropolis: 5,
          },
		},
		requirements: {
			skill: {
				lichdom: 3,
			},
        },
        completed: false,
      },
	  {
        title: "Blood",
        text: "\"... And the rivers will run red with blood.\" Of course, no ritual is complete without blood. Now, where can I find some?",
		objectives: {
			skill: {
            lichdom: 3,
          },
		},
		requirements: {
			skill: {
				lichdom: 4,
			},
        },
        completed: false,
      },
	  {
        title: "Evolution",
        text: "Okay, let me just make a mental copy of some of these sigils, and voilà! I should have the recipe to evolve now.",
		objectives: {
			skill: {
            lichdom: 4,
          },
		},
		requirements: {
			skill: {
				lichdom: 5,
			},
        },
        completed: false,
      },	
      {
        title: "Grave Digging",
        text: "Not many quality bones in this grave. If I explore more and could dig deeper, I'm sure I could find more.\n\nThe output of some Schemes are modified by Vices, Map, or Knowledge.",
        image: null,
		requirements: {
          milestone: "bones"
        },
        completed: false,
      },
      {
        title: "Bones",
        text: "These bones invigorate me; I feel my power level rising! The crows can sense it too.\n\nBones will increase your strength or Dread, allowing you to survive longer.",
        image: null,
		objectives: {
			skill: {
				lichdom: 3,
			},
		},
		requirements: {
          //map: {
            //bones: 5,
          //},
		  skill: {
			  might: 1,
		  },
        },
        completed: false,
      },	  
      {
        title: "Crows",
        text: "The crows really didn't like me hunting one of them. Maybe if I can disguise myself, they will ignore me.",
        image: null,
		objectives: {
          //map: {
            //bones: 5,
          //},
		  skill: {
			  might: 1,
		  },
		},
		requirements: {
          milestone: 'crows',
        },
        completed: false,
      },
      {
        title: "Baby No More",
        text: "I assemble the pieces, draw the ritual sigil, and channel my power. I evolve into ... a kid. It's a start and I should be able to reach the latch now to get out of here and see what lies beyond. My first steps out of the graveyard quickly transport me into a forest, but something about it feels off. Before I can put a bone on it, a bear appears out of nowhere and mauls me. It looks like things are just going to get tougher.",
        image: "lichkid",
		objectives: {
          //milestone: 'crows',
		  skill: {
			  lichdom: 5,
		  },
		},
		requirements: {
          milestone: "Evolve - Kid",
        },
        completed: false,
        //tutorial3: true,
      },
      {
        title: "Visions",
        text: "After being reborn, my skull is wracked with memories. I see through the eyes of your infant self, being held gently by man. The stars gleam coldly above as he places me in the heart of a remote graveyard, my graveyard. His voice, both stern and soft, lingers in the air, \"Be strong, little one. This world will challenge you, but in you lies the power to rise anew.\" The scene fades with the echo of his cryptic farewell.",
        image: null,
		requirements: {
          milestone: "Evolve - Kid",
        },
        completed: false,
		tutorial3: true,
      },	  
      {
        title: "Bear Problems",
        text: "I need another tactic to throw off the bear from viewing me as a threat. Maybe if I just feign death. It should be easy for me.",
        image: "forest",
		objectives: {
          milestone: "Evolve - Kid",
		},
		requirements: {
		  skill: {
			  forest: 1,
		  },
        },
        completed: false,
      },
      {
        title: "Wood",
        text: "There is a lot of sticks lying around. I'm not sure why I would need it but I can collect some wood here.",
        image: null,
		requirements: {
			skill: {
			  forest: 2,
		  },
        },
        completed: false,
      },
      {
        title: "Smokey Swamp",
        text: "I spot a swamp bubbling with a foul stench. I don't know how to escape this forest yet, but I should think about my next evolution. I bet I can dredge up some bones from that swamp.",
        image: "swamp",
		requirements: {
			skill: {
			  forest: 3,
		  },
        },
        completed: false,
      },
	  {
        title: "Wildlife",
        text: "Once again, I need a bit of blood. Luckily, there are smaller animals besides the bear in this forest. Time to hunt or be hunted, or both...",
        image: null,
		requirements: {
			skill: {
			  forest: 4,
		  },
        },
        completed: false,
      },
	  {
        title: "Mysterious Rocks",
        text: "I find some rocks with feint glow that emanates power. Could this be lingering magic from a long-lost civilization? I should be able to absorb it.",
        image: null,
		objectives: {
          skill: {
            forest: 6,
          },
		},
		requirements: {
			skill: {
			  forest: 7,
		  },
        },
        completed: false,
      },
	  {
        title: "A School?",
        text: "A break at last! There is a path. I follow a path, which leads me out of the trees to a massive stone complex with large ornate windows. Circling around to the front, I discover it's a school. Robed teenagers, much taller than I, shuffle between classes. It's a magic academy! I hear the snap of a spell, I'm suddenly back at the graveyard.",
        image: null,
		requirements: {
			skill: {
			  forest: 5,
		  },
        },
        completed: false,
		tutorial4: true,
      },
	  {
        title: "Mission Complete",
        text: "It seems there's a groundskeeper at the academy who prevents creatures from the forest from entering. If he thinks I'm a student, maybe I can slip by. Time to prepare for my next evolution.",
        image: null,
		objectives: {
          skill: {
            forest: 1,
          },
		},
		requirements: {
			skill: {
			  forest: 6,
		  },
        },
        completed: false,
      },
      {
        title: "Something Alive",
        text: "There's something alive in here. I'd better be careful. With all the bones drifting around, I bet I can blend in quite well.",
        image: null,
		requirements: {
			skill: {
				swamp: 1,
			}
        },
        completed: false,
      },
      {
        title: "Dredging",
        text: "This swamp is a treasure trove of bones, though many are broken or rotten. It will take a while to find the good ones, but I bet the yields will eventually be much better. Having something long to collect the bones with would help.",
        image: null,
		objectives: {
			skill: {
				forest: 3,
          },
		},
		requirements: {
			skill: {
				swamp: 2,
			}
        },
        completed: false,
      },
      {
        title: "Shrooms",
        text: "With all the rot and decay around, there are a lot of shrooms growing. This is a good place to collect some.",
        image: null,
		objectives: {
			skill: {
				swamp: 2,
          },
		},
		requirements: {
			skill: {
				swamp: 3,
			}
        },
        completed: false,
      },
	  
	  {
        title: "Hag One",
        text: "A green, mouldy hag emerges from the swamp, looks deeply into my skull, and says, \"We have been watching you. You die, yet persist.\" Then, she submerges back into the swamp.",
        image: null,
		requirements: {
			skill: {
				swamp: 5,
			}
        },
        completed: false,
      },
	  {
        title: "Hag Two",
        text: "Another hag emerges from the swamp to speak with me. She looks very similar to the previous one, except for the bumps. \"The land bears a curse, death is no more. Seek out your soul, to mend and restore.\"",
        image: null,
		requirements: {
			skill: {
				swamp: 6,
			}
        },
        completed: false,
      },
	  {
        title: "Hag Three",
        text: "A third hag emerges and speaks, \"You cheat death, and so does the King.\"",
        image: null,
		requirements: {
			skill: {
				swamp: 7,
			}
        },
        completed: false,
      },	  
	  {
        title: "Coven",
        text: "This time, all three hags emerge, holding an orb glowing with power. They seem unsure what to say this time and start telling me a story about stubbing their toes.",
        image: null,
		requirements: {
			skill: {
				swamp: 7,
			}
        },
        completed: false,
      },		  	  	  
	  {
        title: "Teenager",
        text: "I put my hood up and pull down my sleeves. This edgy look feels very natural. I wait until the groundskeeper is out of sight before emerging from the forest. Following some students inside the academy, I quickly get lost. Eventually, I find myself alone with a teacher in the hall. They raise an eyebrow and snap their fingers. It looks like I need to play the role of a student more convincingly.\n\nThat's it for the demo. Thanks for playing!",
        image: "lichteen",
		objectives: {
			skill: {
			  forest: 6,
		  },
		},
		requirements: {
          milestone: "Evolve - Teenager",
        },
        completed: false,
      },
	  /*
	  {
        title: "Visions Again",
        text: "I am engulfed by unfolding memories. I find myself in a tiny cage. The man from the last vision appears and lifts me to freedom. Suddenly, we're navigating shadowy corridors and moonlit streets. The night is charged with secrecy as he moves through shadowed passages, his cloak concealing our presence. The memory fades as we pass through city gates and enter the forest.",
        image: null,
		requirements: {
          milestone: "Evolve - Teenager",
        },
        completed: false,
      },
*/	  
	  {
        title: "Academy Mapping",
        text: "This place is a labyrinth. Many of the doors are locked; I'm not sure how these students manage to get to their classes.",
        image: null,
		//objectives: {
			//milestone: "Evolve - Teenager",
		//},
		requirements: {
			skill: {
				school: 1,
			}
        },
        completed: false,
      },
	  {
        title: "Attending Class",
        text: "I spot a younger-looking student rushing to a class and follow them inside. It appears to be an introductory course in magic. The teacher, resembling an older student, doesn't mind the extra attendee. Thus begins my foray into magic.",
        image: null,
		objectives: {
			milestone: "Evolve - Teenager",
		},
		requirements: {
			skill: {
				school: 2,
			}
        },
        completed: false,
      },
	  {
        title: "Pranks",
        text: "I catch some students planning a prank and decide to egg them on. They send a few sparks down the hallway – not particularly creative, but it succeeds in drawing the teachers' attention, who promptly chase after them. This could be a useful way to divert attention. I also notice that students exchange collectible coins (spoils) for favors; I should find ways to acquire some.",
        image: null,
		requirements: {
			skill: {
				school: 3,
			}
        },
        completed: false,
      },
	  {
        title: "Mana Font",
        text: "There is a mana fountain in one of the courtyards to siphon mana from. However, there's quite a long line. I wonder if someone will let me cut in.",
        image: null,
		requirements: {
			skill: {
				school: 4,
			}
        },
        completed: false,
      },
	  {
        title: "The Gardens",
        text: "Outside, there's a lovely garden, albeit with a funky smell. I stumble upon a herbalism club called 'Wierd Weeds'. The members are very friendly and begin showing me all the cool things that can be made with plants.",
        image: "weedclub",
		requirements: {
			skill: {
				school: 5,
			}
        },
        completed: false,
      },
	  {
        title: "The Stables",
        text: "Also outside is an elegant stable with expansive riding grounds. Peering inside, I'm greeted by 'Equestrians for Equality'. They view the creatures they mount as equals and are eager to debate the topic.",
        image: "debateclub",
		requirements: {
			skill: {
				school: 6,
			}
        },
        completed: false,
      },
	  {
        title: "Attic",
        text: "Finding a ladder, I climb up to the attic of the academy. To my surprise, I find students gathered around an unusual device. A couple of nervous students, members of a club dedicated to 'Planar Problems', introduce themselves. They're concerned about menaces from other planes and keep a watchful eye with divination tools.",
        image: "planarclub",
		requirements: {
			skill: {
				school: 7,
			}
        },
        completed: false,
      },
	  {
        title: "Dungeon",
        text: "After thoroughly exploring the academy, I lean on a brazier, and surprisingly, the wall behind me opens. Not exactly well-concealed. A staircase leading downward is revealed, indicating a whole dungeon complex beneath the academy. Time to explore again.",
        image: null,
		requirements: {
			skill: {
				school: 8,
			}
        },
        completed: false,
      },
	  {
        title: "The Curse",
        text: "A student distracts the teacher by inquiring about the origin of the curse. The teacher responds with a shrug, saying, \"Nothing is known for certain, but as death and time began to halt, the King rose to power. Quite fortuitous, isn't it?\"",
        image: null,
		requirements: {
			skill: {
				'class': 1,
			}
        },
        completed: false,
      },	  
	  {
        title: "Cheating",
        text: "I've found a way to earn some coins: by providing test answers to students in exchange.",
        image: null,
		objectives: {
			skill: {
				'school': 1,
			}
		},
		requirements: {
			skill: {
				'class': 2,
			}
        },
        completed: false,
      },
	  
	  {
        title: "Mage Hand",
        text: "I've learned the spell 'Mage Hand'. Now I can open things beyond my reach!",
        image: null,
		objectives: {
			skill: {
				'class': 2,
			}
		},
		requirements: {
			skill: {
				'class': 3,
			}
        },
        completed: false,
      },
	  
	  {
        title: "Magic Missile",
        text: "I've learned the spell 'Magic Missile'. It's great for clearing out pests.",
        image: null,
		objectives: {
			skill: {
				'class': 3,
			}
		},
		requirements: {
			skill: {
				'class': 5,
			}
        },
        completed: false,
      },
	  {
        title: "Fight Club",
        text: "Following the sounds of violent spellcasting, I stumble upon students engaged in battle, careful not to cause serious harm. Caught snooping, I'm interrogated about my presence. Flipping the questions on them, I learn they're the 'Ascendant Adventurers', a semi-official club for aspiring adventurers.",
        image: "aaclub",
		requirements: {
			skill: {
				school: 9,
			}
        },
        completed: false,
      },
	  {
        title: "Game Night",
        text: "Drawn by a peculiar aura of death, I discover its source: students shrouded in darkness, playing with undead rats, frozen in place on a table. They're part of a gaming group called 'Live Action Necromancy' or 'LAN'. While their necromantic skills are basic, they're sufficient for complex games with raised rats as pieces.",
        image: "lanclub",
		requirements: {
			skill: {
				school: 10,
			}
        },
        completed: false,
      },
	  {
        title: "Crypts",
        text: "Beneath the academy are crypts that likely hold many bones. However, they're swarming with rats, making it difficult to loot the bones freely.",
        image: null,
		requirements: {
			skill: {
				school: 11,
			}
        },
        completed: false,
      },
	  {
        title: "To Town",
        text: "I've found a way out of the school, but it appears to be guarded and restricted to adults only.",
        image: null,
		objectives: {
			skill: {
				school: 1,
			}
		},
		requirements: {
			skill: {
				school: 12,
			}
        },
        completed: false,
      },
	  {
        title: "Regrowth",
        text: "Curious about the rapid regrowth of the weeds, I ask a club member. They reply enthusiastically, 'Isn't it wonderful! I no longer have to wait to practice my pruning.'",
        image: null,
		requirements: {
			skill: {
				ww: 2,
			}
        },
        completed: false,
      },	  
	  {
        title: "Donate",
        text: "They have an insatiable appetite for shrooms here. Can't get enough of them. It's a good way to earn Coins.",
        image: null,
		requirements: {
			skill: {
				ww: 4,
			}
        },
        completed: false,
      },
	  {
        title: "Potions",
        text: "The club members teach me how to make potions using the shrooms. The potential combinations seem limitless.",
        image: null,
		objectives: {
			skill: {
				school: 5,
			}
		},
		requirements: {
			skill: {
				ww: 6,
			}
        },
        completed: false,
      },
	  {
        title: "Circles",
        text: "The points of debate often go in circles, but each time I notice there's a slight difference in tone or pauses.",
        image: null,
		requirements: {
			skill: {
				ee: 2,
			}
        },
        completed: false,
      },	  
	  {
        title: "Creatures",
        text: "Having learned their arguments on equality, I'm now allowed access to the creatures. Despite the name 'Equestrians', there's little to no riding involved. Familiarizing myself with these creatures offers a chance to earn Coins.",
        image: null,
		requirements: {
			skill: {
				ee: 4,
			}
        },
        completed: false,
      },
	  {
        title: "Mount",
        text: "It seems that with enough Coins, they'll allow me to 'borrow' a mount. This could be useful for getting out of here.",
        image: null,
		objectives: {
			skill: {
				school: 6,
			}
		},
		requirements: {
			skill: {
				ee: 6,
			}
        },
        completed: false,
      },
	  {
        title: "Theories",
        text: "One of the prevailing theories is that the curse was brought on by demons from another plane and that one day they will return, bringing the apocalypse with them.",
        image: null,
		requirements: {
			skill: {
				pp: 4,
			}
        },
        completed: false,
      },	  
	  {
        title: "Scrying",
        text: "Now that I've been made aware of the various threats out there, they let me use their scrying device to keep watch. I can claim to have seen just about anything, and they'll give me Coins for it.",
        image: null,
		requirements: {
			skill: {
				pp: 4,
			}
        },
        completed: false,
      },	  
	  {
        title: "Third Eye",
        text: "They're allowing me to use their scrying device for personal use.",
        image: null,
		objectives: {
			skill: {
				school: 7,
			}
		},
		requirements: {
			skill: {
				pp: 6,
			}
        },
        completed: false,
      },
	  {
        title: "Preparation",
        text: "These students are committed to fighting the good fight and finding a solution to the curse, endlessly training for the cause.",
        image: null,
		requirements: {
			skill: {
				aa: 2,
			}
        },
        completed: false,
      },	  
	  {
        title: "Adventuring Gear",
        text: "They have some basic supplies for sale, available to those who have the Coin.",
        image: null,
		requirements: {
			skill: {
				aa: 4,
			}
        },
        completed: false,
      },
	  {
        title: "Blasting",
        text: "Now that I'm fully versed in all the safety measures, they trust me enough to cast spells at them. It should be good practice.",
        image: null,
		objectives: {
			skill: {
				school: 9,
			}
		},
		requirements: {
			skill: {
				aa: 6,
			}
        },
        completed: false,
      },
	  {
        title: "Fixed rolls",
        text: "Even with each die roll predetermined, the students still get ecstatic over unnatural 20s.",
        image: null,
		requirements: {
			skill: {
				lan: 2,
			}
        },
        completed: false,
      },	  
	  {
        title: "Battle Rats",
        text: "I think I understand enough now to play and raise some rats. They seem to wager Coins on the games. It's probably not a significant source of Coins, but it's a chance to learn control over the undead.",
        image: null,
		requirements: {
			skill: {
				lan: 4,
			}
        },
        completed: false,
      },
	  {
        title: "Rituals",
        text: "Apart from summoning rats, the 'LAN' club experiments with blood magic, albeit with minimal effect. Not many students are willing to donate their blood, but Coins seem to persuade them.",
        image: null,
		objectives: {
			skill: {
				school: 10,
			}
		},
		requirements: {
			skill: {
				lan: 6,
			}
        },
        completed: false,
      },
      {
        title: "Adulthood",
        text: "Finally an adult, I immediately draw looks from students and teachers alike at school. It's time to leave. I walk out the front gate without issue and head down the road.",
        image: "lichadult",
		objectives: {
			skill: {
				school: 12,
			}
		},
		requirements: {
          milestone: "evolve3",
        },
        completed: false,
      },
      {
        title: "City Life",
        text: "It's quite a journey before I reach a large city with three major districts. In the town center, there's a parade for the King. The crowd cheers for 'Gavriel'. I spot this Gavriel, the King, seated on a throne carried by peasants. He's the man from my visions! He turns to me and smirks. Suddenly, guards grab me and hand me over to the clerics for exorcism.",
        image: "town",
		requirements: {
          milestone: "evolve3",
        },
        completed: false,
        tutorial5: true,
      }, 
      {
        title: "Answers",
		text: "Visions flood my mind once more. There I am, the Lord of Death, ensnared in a binding circle by Gavriel, my phylactery in his grasp. Days, years, ages pass, and my form dwindles to that of a toddler. Unable to fulfill my role as the bringer of death, the world has slipped into a quasi-state of stasis. But why would he set me free?",
        image: null,
		requirements: {
          milestone: "evolve3",
        },
        completed: false,
      }, 
      {
        title: "The Plan",
		text: "Gavriel possesses my phylactery. I must confront him and reclaim it. He undoubtedly knows I'm coming now. And if he had the power to bind me before, he will be a formidable opponent.",
        image: null,
		requirements: {
          milestone: "evolve3",
        },
        completed: false,
      },	  
		/*
      {
        title: "Lowtown",
        text: "Lowtown, or rather the slums, seems to house the disenfranchised.",
        image: null,
		requirements: {
			skill: {
				lowtown: 1,
			}
        },
        completed: false,
      },
	  */
	  {
        title: "Slums",
        text: "In Lowtown, I come across the Slums.",
        image: "slums",
		requirements: {
			skill: {
				triangle: 1,
			}
        },
        completed: false,
      },
      {
        title: "Docks",
        text: "It seems many people in Lowtown head to the Docks for fishing as a means to an end.",
        image: "docks",
		requirements: {
			skill: {
				slums: 4,
			}
        },
        completed: false,
      },
      {
        title: "Tavern",
        text: "I notice some fishermen heading to the local Tavern to spend their hard-earned money.",
        image: "tavern",
		requirements: {
			skill: {
				docks: 4,
			}
        },
        completed: false,
      },
      {
        title: "Pits",
        text: "A drunken patron lets slip that there are underground magical battle pits in Lowtown.",
        image: "pits",
		requirements: {
			skill: {
				tavern: 4,
			}
        },
        completed: false,
      },
	  /*
      {
        title: "Corpse Collection - Lowtown",
        text: "It is unfortunate to say but the guards seems to pay less attention to people who go missing in Lowtown. I will attract less suspicion collecting corpses here.",
        image: null,
		objectives: {
			milestone: "evolve3",
		},		
		requirements: {
			skill: {
				lowtown: 5,
			}
        },
        completed: false,
      },
	  */
      {
        title: "Charity",
        text: "People are really grateful for even a few Coins.",
        image: null,
		requirements: {
			skill: {
				slums: 1,
			}
        },
        completed: false,
      },	  
      {
        title: "Laying Low",
        text: "With the support of the people, I can stay under the radar and avoid the authorities.",
        image: null,
		requirements: {
			skill: {
				slums: 3,
			}
        },
        completed: false,
      },
      {
        title: "Dissidents",
        text: "There are many who are upset with the King. If I have supplies to offer them, they might support me.",
        image: null,
		objectives: {
			skill: {
				triangle: 1,
			}
		},	
		requirements: {
			skill: {
				slums: 5,
			}
        },
        completed: false,
      },	  
      {
        title: "Fishing",
        text: "This turns out to be more difficult than I thought.",
        image: null,
		requirements: {
			skill: {
				docks: 1,
			}
        },
        completed: false,
      },
      {
        title: "Fish Eyes",
        text: "I notice some fishermen using a scrying device to locate the best fishing spots.",
        image: null,
		requirements: {
			skill: {
				docks: 3,
			}
        },
        completed: false,
      },
      {
        title: "Grand Theft Fish",
        text: "Besides fish, a variety of goods come through the docks. With a little help, I should be able to acquire some.",
        image: null,
		objectives: {
			skill: {
				slums: 4,
			}
		},	
		requirements: {
			skill: {
				docks: 5,
			}
        },
        completed: false,
      },
      {
        title: "Round on the House",
        text: "People become much more talkative with a bit of ale in them.",
        image: null,
		requirements: {
			skill: {
				tavern: 1,
			}
        },
        completed: false,
      },
      {
        title: "Card Games",
        text: "With all the hands memorized, winning some Coins should be easy.",
        image: null,
		requirements: {
			skill: {
				tavern: 3,
			}
        },
        completed: false,
      },
      {
        title: "Mercenaries",
        text: "There are mercenaries for hire lounging around in the tavern. Their price is steep, but they seem worth it.",
        image: null,
		objectives: {
			skill: {
				docks: 4,
			}
		},
		requirements: {
			skill: {
				tavern: 5,
			}
        },
        completed: false,
      },
      {
        title: "They're Brutal",
        text: "The fights here are incredibly brutal!",
        image: null,
		requirements: {
			skill: {
				pits: 1,
			}
        },
        completed: false,
      },
      {
        title: "In the Ring",
        text: "After learning how to look the part, they agree to let me enter the ring.",
        image: null,
		requirements: {
			skill: {
				pits: 3,
			}
        },
        completed: false,
      },
      {
        title: "Corpses",
        text: "The fallen competitors need a burial, but nobody seems to mind if the bodies don't quite make it to their intended destination.",
        image: null,
		objectives: {
			skill: {
				tavern: 4,
			}
		},
		requirements: {
			skill: {
				pits: 5,
			}
        },
        completed: false,
      },
	  /*
      {
        title: "Midtown",
        text: "Midtown has an idylism about it that is ripe with vulnerability.",
        image: null,
		requirements: {
			skill: {
				midtown: 1,
			}
        },
        completed: false,
      },
	  */
      {
        title: "Market",
        text: "I notice a lot of people heading towards a market center.",
        image: "market",
		requirements: {
			skill: {
				triangle: 4,
			}
        },
        completed: false,
      },
      {
        title: "Apothecary",
        text: "In a side alley, some less-than-legal goods are being traded.",
        image: "apoth",
		requirements: {
			skill: {
				market: 4,
			}
        },
        completed: false,
      },
      {
        title: "Cartel",
        text: "The shopkeeper appears to be extorted by the local cart shipping collective. There might be opportunities to get involved with them.",
        image: "cartel",
		requirements: {
			skill: {
				apothecary: 4,
			}
        },
        completed: false,
      },
	  /*	  
      {
        title: "Corpse Collection - Midtown",
        text: "A bonus of collecting corpses in Midtown is that there is often loot to be found.",
        image: null,
		objectives: {
			milestone: "evolve3",
		},	
		requirements: {
			skill: {
				midtown: 5,
			}
        },
        completed: false,
      },
	  */
      {
        title: "Getting Around",
        text: "I should consider renting a horse to navigate around town more quickly.",
        image: null,
		requirements: {
			skill: {
				triangle: 3,
			}
        },
        completed: false,
      },	  
      {
        title: "Loose Change",
        text: "With so many distracted people around, I bet I can lift a few Coins.",
        image: null,
		objectives: {
			milestone: "evolve3",
		},
		requirements: {
			skill: {
				triangle: 5,
			}
        },
        completed: false,
      },
      {
        title: "Feigning Interest",
        text: "As long as I feign interest in their wares, only the shopkeepers bother me.",
        image: null,
		requirements: {
			skill: {
				market: 1,
			}
        },
        completed: false,
      },	  
      {
        title: "Buy Low",
        text: "There's an opportunity to purchase a lot of supplies here at low prices.",
        image: null,
		requirements: {
			skill: {
				market: 3,
			}
        },
        completed: false,
      },
      {
        title: "Sell High",
        text: "With some clever trading, I can turn a profit by buying low and selling high.",
        image: null,
		objectives: {
			skill: {
				triangle: 4,
			}
		},
		requirements: {
			skill: {
				market: 5,
			}
        },
        completed: false,
      },
      {
        title: "Dusting",
        text: "There are a lot of interesting items here. I'm curious about what they all do.",
        image: null,
		requirements: {
			skill: {
				apothecary: 1,
			}
        },
        completed: false,
      },	  
      {
        title: "Shrooms for Sale",
        text: "I discover some useful ingredients in the store, which the owner agrees to sell to me.",
        image: null,
		requirements: {
			skill: {
				apothecary: 3,
			}
        },
        completed: false,
      },
      {
        title: "Potion Brewing",
        text: "Recognizing my skill, the owner allows me to use their crafting station for potion brewing.",
        image: null,
		objectives: {
			skill: {
				market: 4,
			}
		},
		requirements: {
			skill: {
				apothecary: 5,
			}
        },
        completed: false,
      },
      {
        title: "Collection",
        text: "Collecting dues is easy; pretty much everyone pays up without issue.",
        image: null,
		requirements: {
			skill: {
				cartel: 1,
			}
        },
        completed: false,
      },	  
      {
        title: "Cartel's Can't",
        text: "I've picked up their lingo, and now they think I'm one of them. This opens up job opportunities beyond simple collections.",
        image: null,
		requirements: {
			skill: {
				cartel: 3,
			}
        },
        completed: false,
      },
      {
        title: "What's in the Cart?",
        text: "No questions asked. They have bodies, and I have uses for them.",
        image: null,
		objectives: {
			skill: {
				apothecary: 4,
			}
		},
		requirements: {
			skill: {
				cartel: 5,
			}
        },
        completed: false,
      },
/*	  
      {
        title: "Uptown",
        text: "Uptown is mostly well guarded mansions where the nobility and wealth merchants live. The castle stronghold looms over the city from here. I will need to take the castle to conqueror the town.",
        image: null,
		requirements: {
			skill: {
				uptown: 1,
			}
        },
        completed: false,
      },
	  */
      {
        title: "Manors",
        text: "The wealthy folk reside Uptown. It seems there's an opportunity to work as a servant there.",
        image: "manor",
		requirements: {
			skill: {
				triangle: 2,
			}
        },
        completed: false,
      },	  
      {
        title: "Barracks",
        text: "The local militia appears to be open to new recruits.",
        image: "barracks",
		requirements: {
			skill: {
				manors: 4,
			}
        },
        completed: false,
      },
      {
        title: "Wizard's Watch",
        text: "The more talented recruits are sent to the Wizard's Watch for advanced training. I should be able to learn far more spells there than at the academy.",
        image: "wizard",
		requirements: {
			skill: {
				barracks: 4,
			}
        },
        completed: false,
      },
      {
        title: "Theater",
        text: "I stumble upon a secret society of necromancers who perform private shows for the elite.",
        image: "theater",
		requirements: {
			skill: {
				wizards: 4,
			}
        },
        completed: false,
      },
	  /*
      {
        title: "Corpse Collection - Uptown",
        text: "It is very risky collecting corpses in uptown, but not impossible. The spoils are great, and may have important documents.",
        image: null,
		objectives: {
			milestone: "evolve3",
		},	
		requirements: {
			skill: {
				uptown: 5,
			}
        },
        completed: false,
      }, 
	  */	
      {
        title: "Whispers",
        text: "The work is more demanding than I anticipated. As long as I perform my tasks well, the homeowners hardly notice my presence.",
        image: null,
		requirements: {
			skill: {
				manors: 1,
			}
        },
        completed: false,
      },	  
      {
        title: "Blackmail",
        text: "I overhear many secrets from my clients. A well-crafted threatening letter should yield a good amount of Coin.",
        image: null,
		requirements: {
			skill: {
				manors: 3,
			}
        },
        completed: false,
      },
      {
        title: "Schemes",
        text: "Many of the secrets I've uncovered involve court intrigue. There could be opportunities to find useful allies among the nobles.",
        image: null,
		objectives: {
			skill: {
				triangle: 2,
			}
		},
		requirements: {
			skill: {
				manors: 5,
			}
        },
        completed: false,
      },
      {
        title: "Drill Baby Drill",
        text: "It turns out to be a good physical workout.",
        image: null,
		requirements: {
			skill: {
				barracks: 1,
			}
        },
        completed: false,
      },	  
      {
        title: "Patrol",
        text: "Having learned how the guards operate, I can convincingly pass as one and take on basic patrol routes for Coin.",
        image: null,
		requirements: {
			skill: {
				barracks: 3,
			}
        },
        completed: false,
      },
      {
        title: "Bribe Guards",
        text: "Patrolling the town and walls doesn't pay much, but a bit of Coin should persuade the guards to look the other way for a while.",
        image: null,
		objectives: {
			skill: {
				manors: 4,
			}
		},
		requirements: {
			skill: {
				barracks: 5,
			}
        },
        completed: false,
      },
      {
        title: "Lecture Hall",
        text: "I can sit in the back of the lecture hall and pick up some of the finer points of Magic.",
        image: null,
		requirements: {
			skill: {
				wizards: 1,
			}
        },
        completed: false,
      },	  
      {
        title: "Mana Pool",
        text: "Another source of Mana discovered. More Mana means more Coins.",
        image: null,
		requirements: {
			skill: {
				wizards: 3,
			}
        },
        completed: false,
      },
      {
        title: "Back Room",
        text: "I stumble upon an old, abandoned autopsy room. It's equipped with the right tools for raising Corpses from the dead.",
        image: null,
		objectives: {
			skill: {
				barracks: 4,
			}
		},
		requirements: {
			skill: {
				wizards: 5,
			}
        },
        completed: false,
      },
      {
        title: "Stagehand",
        text: "Despite being a secret society, the necromancers require a lot of assistance with their shows. The actors can't prepare themselves, and the backstage work is surprisingly tedious.",
        image: null,
		requirements: {
			skill: {
				theater: 1,
			}
        },
        completed: false,
      },	  
      {
        title: "Showtime",
        text: "I've studied the lines enough to participate in the performance. It's a macabre spectacle, featuring bodies in various stages of decay.",
        image: null,
		requirements: {
			skill: {
				theater: 3,
			}
        },
        completed: false,
      },
      {
        title: "Corpse Theft",
        text: "I'm not sure where they source their bodies, but they have plenty. They probably won't notice if a few actors go missing.",
        image: null,
		objectives: {
			skill: {
				wizards: 4,
			}
		},
		requirements: {
			skill: {
				theater: 5,
			}
        },
        completed: false,
      },
	  
      {
        title: "Endless Graves",
        text: "The more I explore, the more graves I find. One could potentially raise an entire army from them...",
        image: null,
		objectives: {
			skill: {
				necropolis: 6,
			},
		},
		requirements: {
          skill: {
            necropolis: 10,
          },
        },
        completed: false,
      },
      {
        title: "Raise Army",
        text: "With my knowledge of magic and ventures into forbidden arts, I should be able to raise a corpse army from the graveyard.",
        image: null,
		objectives: {
			skill: {
				necropolis: 10,
				magic: 1,
			},
		},
		requirements: {
          skill: {
            magic: 30,
          },
        },
        completed: false,
      },
	  {
        title: "Staff of Power",
        text: "There are many stories about buried wizards and the power they wielded with their mystic staffs. I should craft one myself, once I learn how.",
		objectives: {
			skill: {
            lichdom: 5,
          },
		},
		requirements: {
			skill: {
				lichdom: 10,
			},
        },
        completed: false,
      },
	  {
        title: "Bone Staff",
        text: "I believe I have the knowledge now to craft my own staff. I should be able to gather enough bones from the graveyard to create a fitting Bone Staff.",
		objectives: {
			skill: {
            lichdom: 10,
			thaumaturgy: 1,
          },
		},
		requirements: {
			skill: {
				thaumaturgy: 30,
			},
        },
        completed: false,
      },	

	  {
        title: "Buried Spring",
        text: "I may have been mistaken about the Mana Rocks. They don't hold lingering magic but are receiving residual magic from an underground source. I'll need to excavate my way to it.",
        image: null,
		objectives: {
          skill: {
            forest: 7,
          },
		},
		requirements: {
			skill: {
			  forest: 10,
		  },
        },
        completed: false,
      },
	  {
        title: "Blast 'Em",
        text: "With a sufficient amount of Mana, I should be able to blast my way to the underground spring. It promises to be a worthwhile endeavor.",
        image: null,
		objectives: {
          skill: {
            forest: 10,
			destruction: 1,
          },
		},
		requirements: {
			skill: {
			  destruction: 30,
		  },
        },
        completed: false,
      },
	  {
        title: "A Whisper in the Wind",
        text: "I think I've figured out why this forest unnerves me. The large source of mana buried beneath is attracting other planar entities. They hover just beyond the edge of perception, waiting for someone to harness them.",
        image: null,
		objectives: {
          skill: {
            forest: 10,
          },
		},
		requirements: {
			skill: {
			  forest: 20,
		  },
        },
        completed: false,
      },
	  {
        title: "Planar Entities",
        text: "My mere aura commands obedience. I should return to the Forest and see how many Planar beings I can bring under my control.",
        image: null,
		objectives: {
          skill: {
            forest: 20,
			domination: 1,
          },
		},
		requirements: {
			skill: {
			  domination: 30,
		  },
        },
        completed: false,
      },		  
      {
        title: "Hag Orb",
        text: "These hags keep pestering me with their random stories. I wonder if I can outsmart them and acquire their orb.",
        image: null,
		objectives: {
			skill: {
				swamp: 3, 
          },
		},
		requirements: {
			skill: {
				swamp: 10,
			}
        },
        completed: false,
      },	 
      {
        title: "Mystic Orb",
        text: "Given my understanding of planes and the occult, I think I can trick those hags into handing over that orb.",
        image: null,
		objectives: {
			skill: {
				swamp: 10, 
				mysticism: 1,
          },
		},
		requirements: {
			skill: {
				mysticism: 30,
			}
        },
        completed: false,
      },
      {
        title: "What Lies Beneath",
        text: "I've thoroughly explored this swamp and believe many of the bones are from a dragon's corpse. Raising such a beast will require specific magical knowledge.",
        image: null,
		objectives: {
			skill: {
				swamp: 10, 
          },
		},
		requirements: {
			skill: {
				swamp: 20,
			}
        },
        completed: false,
      },	
      {
        title: "Zombie Dragon",
        text: "The time has come to raise the dragon.",
        image: null,
		objectives: {
			skill: {
				swamp: 20, 
				necromancy: 1,
          },
		},
		requirements: {
			skill: {
				necromancy: 30,
			}
        },
        completed: false,
      },	  
	  
      {
        title: "Confrontation",
        text: "Deep within the castle dungeons, I finally confront Gavriel. He tightly holds my phylactery, my soul. \"The time has finally come. I wonder what you've got in a fair fight,\" he says.",
        image: null,
		objectives: {
				milestone: "evolve3",
		},	
		requirements: {
			milestone: 'confront',
        },
        completed: false,
      },	  
      {
        title: "Subdued",
        text: "After a long and arduous battle, I finally manage to subdue Gavriel. My phylactery tumbles to the ground before me. Just as I reach for it, Gavriel pleads, \"Wait! Does it have to end like this? I freed you because immortality was a mistake, but now, with death so close, I'm not sure I'm ready.\"",
        image: null,	
		objectives: {
			milestone: "confront",
		},
		requirements: {
			milestone: 'victory',
			notform: 'baby',
        },
        completed: false,
		gameEnd: true,
      },
	  /*
      {
        title: "Baby Victory!",
        text: "After a long and arduous battle, I finally manage to subdue Gavriel. My phylactery tumbles to the ground before me. Just as I crawl towards it, Gavriel pleads, \"To be defeated by a baby! It can't end like this...\"",
        image: "lichbabybw",	
		requirements: {
			milestone: 'victory',
			form: 'baby',
        },
        completed: false,
		gameEnd: true,
      },	
	  */
    ]

    log = [
      //{
        //life: 0,
        //title: "You Little Lich",
        //text: "I am a Lich. I yearn for power and the torment of souls.",
        //image: "littlelich",
      //},
    ];
}

export default new GameData();